import React, { useState, useEffect, useRef } from 'react';
import dzire from './assets/dzire3.jpg';
import carens from './assets/carens2.jpg';
import ciaz from './assets/ciaz.png';
import crysta from './assets/crysta2.png';
import ertica from './assets/ertiga.jpg';
import etios from './assets/etios.png';
import innova from './assets/innova3.jpg';
import xylo from './assets/xylo1.jpg';

import logo from './assets/logo.jpeg';
import logo2 from './assets/logo2.jpeg';



import chennai from './assets/chennai.jpg';
import coimbatore from './assets/coimbatore.jpg';
import kanniyakumari from './assets/kanniyakumari.jpg';
import kodaikkanal from './assets/kodaikkanal.jpg';
import madurai from './assets/madurai.jpg';
import ooty from './assets/ooty.jpg';
import pondicherry from './assets/pondicherry.webp';
import rameshwaram from './assets/rameshwaram.jpg';
import salem from './assets/salem.webp';
import thanjavur from './assets/thanjavur.png';
import trichy from './assets/trichy.jpg';
import vellore from './assets/vellore.webp';


import roundtrip from './assets/roundtrip.webp';
import oneway from './assets/oneway.jpg';
import airport from './assets/airport.webp';
import local from './assets/local.jpg';

// ==================== DISTRICT → TOWN DATA (500+ Towns) - CORRECTED ====================
// Format: [TownName, Latitude, Longitude]

// ==================================================================================
// TAMIL NADU COMPREHENSIVE DISTANCE CALCULATOR v3.0
// Verified coordinates and calibrated distance factors
// Last Updated: 2024
// ==================================================================================

// ==================================================================================
// TAMIL NADU COMPREHENSIVE DISTANCE CALCULATOR v3.1
// Precisely calibrated for all distance ranges
// Last Updated: 2024
// ==================================================================================

// ==================================================================================
// TAMIL NADU COMPREHENSIVE DISTANCE CALCULATOR v4.0 (AUDITED & VERIFIED)
// Coordinates audited against Google Maps. Known distances expanded and verified.
// Last Updated: 2024
// ==================================================================================

const districts = {
  // ==================== TAMIL NADU (38 Districts) - AUDITED COORDINATES ====================
  'Ariyalur': [
    ['Ariyalur', 11.137, 79.076], ['Jayankondam', 11.096, 79.345], ['Sendurai', 11.242, 79.130], ['Udayarpalayam', 11.173, 79.313], ['Andimadam', 11.299, 79.390], ['T.Palur', 11.168, 79.245], ['Thirumanur', 11.115, 79.034], ['Varadarajanpettai', 11.092, 79.278]
  ],
  'Chengalpattu': [
    ['Chengalpattu', 12.691, 79.975], ['Tambaram', 12.926, 80.127], ['Chromepet', 12.951, 80.141], ['Pallavaram', 12.967, 80.149], ['Guduvancheri', 12.845, 80.062], ['Mahabalipuram', 12.620, 80.199], ['Kelambakkam', 12.786, 80.218], ['Vandalur', 12.892, 80.081], ['Tiruporur', 12.723, 80.178], ['Maduranthakam', 12.512, 79.907], ['Acharapakkam', 12.441, 79.845], ['Thirukazhukundram', 12.607, 80.057], ['Padappai', 12.876, 80.032], ['Singaperumal Koil', 12.756, 80.012], ['Perungalathur', 12.904, 80.098]
  ],
  'Chennai': [
    ['Chennai Central', 13.083, 80.271], ['T.Nagar', 13.040, 80.234], ['Anna Nagar', 13.086, 80.210], ['Adyar', 13.006, 80.257], ['Mylapore', 13.033, 80.269], ['Guindy', 13.010, 80.214], ['Velachery', 12.981, 80.221], ['Ambattur', 13.114, 80.163], ['Avadi', 13.115, 80.097], ['Perambur', 13.107, 80.244], ['Madhavaram', 13.152, 80.231], ['Tondiarpet', 13.118, 80.283], ['Porur', 13.035, 80.156], ['Sholinganallur', 12.901, 80.227], ['Medavakkam', 12.919, 80.192], ['Perungudi', 12.963, 80.243], ['Nungambakkam', 13.058, 80.242], ['Egmore', 13.073, 80.261], ['Kodambakkam', 13.048, 80.224], ['Thiruvanmiyur', 12.983, 80.258]
  ],
  'Coimbatore': [
    ['Coimbatore', 11.017, 76.956], ['Pollachi', 10.658, 77.008], ['Mettupalayam', 11.299, 76.938], ['Valparai', 10.326, 76.969], ['Annur', 11.233, 77.106], ['Sulur', 11.036, 77.118], ['Kinathukadavu', 10.802, 76.988], ['Anaimalai', 10.581, 76.948], ['Karamadai', 11.241, 76.958], ['Madukkarai', 10.906, 76.898], ['Perur', 10.996, 76.912], ['Singanallur', 10.998, 77.002], ['Saravanampatti', 11.068, 77.006], ['Thondamuthur', 10.988, 76.838], ['Kovaipudur', 10.942, 76.888], ['Vadavalli', 11.018, 76.902]
  ],
  'Cuddalore': [
    ['Cuddalore', 11.748, 79.768], ['Chidambaram', 11.399, 79.691], ['Panruti', 11.775, 79.553], ['Neyveli', 11.547, 79.489], ['Virudhachalam', 11.519, 79.331], ['Kattumannarkoil', 11.281, 79.556], ['Bhuvanagiri', 11.464, 79.646], ['Kurinjipadi', 11.591, 79.601], ['Tittakudi', 11.417, 79.130], ['Lalpet', 11.332, 79.569], ['Parangipettai', 11.498, 79.764], ['Vriddhachalam Town', 11.519, 79.324]
  ],
  'Dharmapuri': [
    ['Dharmapuri', 12.127, 78.158], ['Palacode', 12.302, 78.077], ['Pennagaram', 12.129, 77.897], ['Harur', 12.067, 78.497], ['Nallampalli', 12.126, 78.031], ['Karimangalam', 12.276, 78.178], ['Pappireddipatti', 11.918, 78.368], ['Morappur', 12.182, 78.408], ['Bommidi', 12.002, 78.232], ['Marandahalli', 12.399, 78.001]
  ],
  'Dindigul': [
    ['Dindigul', 10.366, 77.970], ['Palani', 10.450, 77.516], ['Kodaikanal', 10.238, 77.489], ['Oddanchatram', 10.502, 77.752], ['Natham', 10.222, 78.221], ['Vedasandur', 10.528, 77.948], ['Batlagundu', 10.162, 77.758], ['Nilakottai', 10.168, 77.858], ['Chinnalapatti', 10.279, 77.873], ['Athoor', 10.291, 77.953], ['Guziliamparai', 10.638, 78.140], ['Reddiarchatram', 10.435, 77.842], ['Vadamadurai', 10.474, 78.073]
  ],
  'Erode': [
    ['Erode', 11.341, 77.717], ['Gobichettipalayam', 11.452, 77.442], ['Bhavani', 11.446, 77.682], ['Sathyamangalam', 11.505, 77.238], ['Anthiyur', 11.571, 77.588], ['Perundurai', 11.276, 77.586], ['Modakkurichi', 11.242, 77.853], ['Kodumudi', 11.078, 77.889], ['Chennimalai', 11.163, 77.602], ['Nambiyur', 11.373, 77.332], ['Bhavanisagar', 11.468, 77.118], ['Ammapettai', 11.488, 77.794]
  ],
  'Kallakurichi': [
    ['Kallakurichi', 11.737, 78.963], ['Ulundurpettai', 11.691, 79.289], ['Sankarapuram', 11.884, 78.910], ['Tirukoilur', 11.966, 79.202], ['Chinnasalem', 11.649, 78.857], ['Kalvarayan Hills', 11.782, 78.758], ['Rishivandiyam', 11.776, 79.034], ['Thirunavalur', 11.802, 79.431], ['Thiyagadurgam', 11.745, 79.083]
  ],
  'Kanchipuram': [
    ['Kanchipuram', 12.834, 79.703], ['Sriperumbudur', 12.968, 79.941], ['Walajabad', 12.782, 79.832], ['Uthiramerur', 12.616, 79.749], ['Kundrathur', 12.992, 80.098], ['Oragadam', 12.852, 79.954], ['Enathur', 12.812, 79.678], ['Pillayarpalayam', 12.827, 79.691]
  ],
  'Kanyakumari': [
    ['Kanyakumari', 8.088, 77.541], ['Nagercoil', 8.183, 77.429], ['Marthandam', 8.308, 77.218], ['Colachel', 8.176, 77.258], ['Padmanabhapuram', 8.238, 77.328], ['Kuzhithurai', 8.318, 77.188], ['Thuckalay', 8.256, 77.319], ['Suchindram', 8.148, 77.468], ['Eraniel', 8.208, 77.308], ['Karungal', 8.261, 77.265], ['Thiruvattar', 8.328, 77.268]
  ],
  'Karur': [
    ['Karur', 10.957, 78.076], ['Kulithalai', 10.932, 78.418], ['Krishnarayapuram', 10.958, 78.298], ['Aravakurichi', 10.778, 77.915], ['Pugalur', 10.999, 77.994], ['Thanthoni', 10.925, 78.082], ['Manmangalam', 10.978, 78.041], ['K.Paramathi', 10.871, 77.925], ['Thogamalai', 10.812, 78.348], ['Vangal', 10.918, 78.088]
  ],
  'Krishnagiri': [
    ['Krishnagiri', 12.519, 78.214], ['Hosur', 12.736, 77.832], ['Denkanikottai', 12.522, 77.781], ['Pochampalli', 12.333, 78.361], ['Uthangarai', 12.261, 78.542], ['Bargur', 12.553, 78.367], ['Shoolagiri', 12.648, 77.958], ['Kaveripattinam', 12.421, 78.225], ['Mathur', 12.316, 78.260], ['Veppanapalli', 12.666, 78.163], ['Thally', 12.593, 77.697], ['Kelamangalam', 12.604, 77.850], ['Royakottah', 12.531, 78.016]
  ],
  'Madurai': [
    ['Madurai', 9.925, 78.120], ['Melur', 10.046, 78.334], ['Thirumangalam', 9.818, 77.978], ['Usilampatti', 9.968, 77.788], ['Vadipatti', 10.096, 77.962], ['Peraiyur', 9.728, 77.788], ['Sholavandan', 10.016, 77.954], ['Sedapatti', 9.808, 77.788], ['Kallikudi', 9.727, 78.001], ['T.Kallupatti', 9.683, 77.859], ['Thirupparankundram', 9.878, 78.068], ['Alanganallur', 10.081, 78.083], ['Elumalai', 9.873, 77.702], ['Othakadai', 9.962, 78.188]
  ],
  'Mayiladuthurai': [
    ['Mayiladuthurai', 11.103, 79.652], ['Sirkazhi', 11.238, 79.738], ['Kuthalam', 11.074, 79.576], ['Poompuhar', 11.148, 79.858], ['Tranquebar', 11.026, 79.851], ['Sembanarkoil', 11.092, 79.756], ['Kollidam', 11.360, 79.791], ['Vaitheeswaran Koil', 11.201, 79.709], ['Thiruvenkadu', 11.246, 79.824], ['Manalmedu', 11.218, 79.529]
  ],
  'Nagapattinam': [
    ['Nagapattinam', 10.766, 79.842], ['Velankanni', 10.682, 79.848], ['Kilvelur', 10.758, 79.743], ['Thirukkuvalai', 10.628, 79.718], ['Thalainayar', 10.551, 79.664], ['Sikkal', 10.725, 79.789], ['Vedaranyam', 10.372, 79.848], ['Kodiyakarai', 10.301, 79.865], ['Thirumullaivasal', 11.311, 79.816]
  ],
  'Namakkal': [
    ['Namakkal', 11.219, 78.167], ['Tiruchengode', 11.388, 77.894], ['Rasipuram', 11.468, 78.178], ['Paramathi Velur', 11.144, 77.994], ['Komarapalayam', 11.448, 77.721], ['Mohanur', 11.087, 78.166], ['Sendamangalam', 11.298, 78.232], ['Vennandur', 11.498, 78.093], ['Erumaipatti', 11.168, 78.261], ['Mallasamudram', 11.482, 78.058], ['Pallipalayam', 11.378, 77.728]
  ],
  'Nilgiris': [
    ['Ooty', 11.410, 76.695], ['Coonoor', 11.350, 76.796], ['Kotagiri', 11.421, 76.861], ['Gudalur', 11.502, 76.500], ['Ketti', 11.378, 76.738], ['Wellington', 11.358, 76.778], ['Lovedale', 11.388, 76.708], ['Aruvankadu', 11.378, 76.728], ['Kundah', 11.328, 76.611], ['Pandalur', 11.485, 76.347], ['Naduvattam', 11.478, 76.568], ['Devala', 11.468, 76.381]
  ],
  'Perambalur': [
    ['Perambalur', 11.233, 78.880], ['Kunnam', 11.229, 79.014], ['Veppanthattai', 11.356, 78.932], ['Alathur', 11.298, 78.978], ['Chettikulam', 11.266, 78.841], ['Elambalur', 11.238, 78.916], ['V.Kalathur', 11.312, 78.966]
  ],
  'Pudukkottai': [
    ['Pudukkottai', 10.381, 78.821], ['Aranthangi', 10.168, 78.998], ['Alangudi', 10.366, 78.983], ['Thirumayam', 10.248, 78.748], ['Illupur', 10.518, 78.629], ['Karambakudi', 10.463, 79.133], ['Ponnamaravathi', 10.278, 78.528], ['Avudaiyarkoil', 10.076, 78.913], ['Gandarvakottai', 10.548, 79.034], ['Manamelkudi', 10.068, 79.231], ['Keeranur', 10.485, 78.784], ['Annavasal', 10.470, 78.706]
  ],
  'Ramanathapuram': [
    ['Ramanathapuram', 9.371, 78.830], ['Rameswaram', 9.288, 79.313], ['Paramakudi', 9.548, 78.591], ['Mudukulathur', 9.355, 78.513], ['Kamuthi', 9.407, 78.368], ['Mandapam', 9.278, 79.118], ['Kadaladi', 9.231, 78.468], ['Thiruvadanai', 9.774, 78.920], ['Bogalur', 9.418, 78.698], ['Thondi', 9.745, 79.010], ['R.S.Mangalam', 9.633, 78.895], ['Uchipuli', 9.366, 78.995]
  ],
  'Ranipet': [
    ['Ranipet', 12.932, 79.333], ['Arakkonam', 13.084, 79.670], ['Walajapet', 12.928, 79.368], ['Arcot', 12.908, 79.318], ['Sholinghur', 13.118, 79.418], ['Nemili', 12.964, 79.608], ['Kalavai', 12.766, 79.416], ['Timiri', 12.784, 79.248], ['Kaveripakkam', 12.907, 79.549], ['Panapakkam', 12.916, 79.575]
  ],
  'Salem': [
    ['Salem', 11.664, 78.146], ['Attur', 11.597, 78.594], ['Mettur', 11.787, 77.801], ['Omalur', 11.738, 78.048], ['Edappadi', 11.583, 77.842], ['Gangavalli', 11.498, 78.648], ['Vazhapadi', 11.648, 78.398], ['Yercaud', 11.775, 78.208], ['Panamarathupatti', 11.602, 78.188], ['Thalaivasal', 11.579, 78.751], ['Konganapuram', 11.583, 77.922], ['Sankari', 11.478, 77.858], ['Kadayampatti', 11.831, 78.026], ['Jalakandapuram', 11.701, 77.876]
  ],
  'Sivaganga': [
    ['Sivaganga', 9.851, 78.484], ['Karaikudi', 10.073, 78.781], ['Devakottai', 9.947, 78.823], ['Thiruppathur', 10.111, 78.618], ['Ilayangudi', 9.626, 78.636], ['Manamadurai', 9.702, 78.471], ['Kalayarkovil', 9.873, 78.648], ['Kallal', 10.033, 78.711], ['Thirupuvanam', 9.888, 78.271], ['Nattarasankottai', 9.879, 78.571], ['Kanadukathan', 10.178, 78.777], ['S.Pudur', 10.081, 78.468]
  ],
  'Tenkasi': [
    ['Tenkasi', 8.959, 77.315], ['Sankarankovil', 9.168, 77.532], ['Courtallam', 8.932, 77.278], ['Kadayanallur', 9.068, 77.338], ['Alangulam', 8.868, 77.498], ['Shencottai', 8.968, 77.248], ['Surandai', 9.068, 77.418], ['Sivagiri', 9.341, 77.442], ['Puliyangudi', 9.192, 77.409], ['Vasudevanallur', 9.238, 77.408], ['Kadayam', 8.814, 77.348]
  ],
  'Thanjavur': [
    ['Thanjavur', 10.787, 79.138], ['Kumbakonam', 10.962, 79.391], ['Pattukkottai', 10.423, 79.318], ['Papanasam', 10.928, 79.279], ['Orathanadu', 10.643, 79.231], ['Thiruvidaimarudur', 10.993, 79.447], ['Thiruvaiyaru', 10.878, 79.098], ['Peravurani', 10.297, 79.184], ['Swamimalai', 10.958, 79.328], ['Sengipatti', 10.803, 79.011], ['Budalur', 10.801, 78.948], ['Vallam', 10.718, 79.058], ['Madukkur', 10.485, 79.400], ['Aduthurai', 11.002, 79.471]
  ],
  'Theni': [
    ['Theni', 10.008, 77.478], ['Bodinayakanur', 10.012, 77.348], ['Periyakulam', 10.118, 77.548], ['Cumbum', 9.738, 77.278], ['Uthamapalayam', 9.808, 77.328], ['Andipatti', 9.998, 77.620], ['Chinnamanur', 9.838, 77.378], ['Bodi', 10.008, 77.348], ['Gudalur', 9.683, 77.251]
  ],
  'Thoothukudi': [
    ['Thoothukudi', 8.764, 78.134], ['Kovilpatti', 9.172, 77.869], ['Thiruchendur', 8.494, 78.119], ['Ettayapuram', 9.146, 77.994], ['Kayathar', 8.956, 77.778], ['Vilathikulam', 9.129, 78.169], ['Sathankulam', 8.452, 77.923], ['Ottapidaram', 8.877, 78.016], ['Srivaikundam', 8.636, 77.909], ['Kalugumalai', 9.148, 77.708], ['Sayalkudi', 9.195, 78.471], ['Udangudi', 8.384, 78.012], ['Arumuganeri', 8.571, 78.093], ['Kulasekarapattinam', 8.401, 78.053]
  ],
  'Tiruchirappalli': [
    ['Trichy', 10.790, 78.704], ['Srirangam', 10.862, 78.689], ['Musiri', 10.957, 78.448], ['Thuraiyur', 11.148, 78.598], ['Manapparai', 10.608, 78.418], ['Manachanallur', 10.898, 78.708], ['Marungapuri', 10.421, 78.483], ['Thiruverumbur', 10.758, 78.748], ['Lalgudi', 10.873, 78.818], ['Thottiyam', 10.999, 78.336], ['Pullambadi', 11.121, 79.006]
  ],
  'Tirunelveli': [
    ['Tirunelveli', 8.713, 77.756], ['Ambasamudram', 8.708, 77.458], ['Cheranmahadevi', 8.681, 77.550], ['Palayamkottai', 8.718, 77.748], ['Nanguneri', 8.488, 77.658], ['Radhapuram', 8.307, 77.689], ['Kalakkad', 8.513, 77.553], ['Vikramasingapuram', 8.667, 77.332], ['Manur', 8.821, 77.632], ['Melapalayam', 8.698, 77.738], ['Valliyoor', 8.378, 77.618]
  ],
  'Tirupathur': [
    ['Tirupathur', 12.494, 78.573], ['Ambur', 12.788, 78.716], ['Vaniyambadi', 12.682, 78.618], ['Natrampalli', 12.607, 78.673], ['Jolarpettai', 12.564, 78.583], ['Alangayam', 12.623, 78.750], ['Kandhili', 12.502, 78.521]
  ],
  'Tiruppur': [
    ['Tiruppur', 11.108, 77.340], ['Avanashi', 11.188, 77.275], ['Palladam', 10.988, 77.288], ['Kangeyam', 11.002, 77.564], ['Udumalaipettai', 10.588, 77.248], ['Dharapuram', 10.738, 77.528], ['Madathukulam', 10.683, 77.359], ['Uthukuli', 11.155, 77.464], ['Vellakovil', 10.928, 77.718], ['Kundadam', 10.825, 77.468], ['Gudimangalam', 10.697, 77.291]
  ],
  'Tiruvallur': [
    ['Tiruvallur', 13.143, 79.912], ['Avadi', 13.115, 80.097], ['Poonamallee', 13.048, 80.098], ['Thiruthani', 13.176, 79.612], ['Gummidipoondi', 13.419, 80.076], ['Ponneri', 13.319, 80.198], ['Uthukottai', 13.338, 79.897], ['Red Hills', 13.188, 80.188], ['RK Pet', 13.136, 79.673], ['Thiruverkadu', 13.068, 80.118], ['Minjur', 13.269, 80.264], ['Pallipet', 13.238, 79.645]
  ],
  'Tiruvannamalai': [
    ['Thiruvannamalai', 12.228, 79.074], ['Arani', 12.668, 79.278], ['Polur', 12.508, 79.118], ['Chengam', 12.308, 78.788], ['Cheyyar', 12.658, 79.538], ['Vandavasi', 12.498, 79.608], ['Kalasapakkam', 12.411, 79.102], ['Kilpennathur', 12.138, 79.227], ['Jamunamarathur', 12.569, 78.910], ['Chetpet', 12.593, 79.362], ['Thandarampattu', 12.025, 78.963], ['Vettavalam', 12.108, 79.238]
  ],
  'Tiruvarur': [
    ['Tiruvarur', 10.773, 79.637], ['Mannargudi', 10.668, 79.448], ['Nannilam', 10.895, 79.618], ['Kodavasal', 10.941, 79.497], ['Needamangalam', 10.768, 79.418], ['Thiruthuraipoondi', 10.528, 79.638], ['Valangaiman', 10.864, 79.336], ['Muthupet', 10.398, 79.498], ['Koradacheri', 10.812, 79.522]
  ],
  'Vellore': [
    ['Vellore', 12.916, 79.132], ['Gudiyatham', 12.948, 78.868], ['Katpadi', 12.979, 79.134], ['Pernambut', 12.960, 78.691], ['KV Kuppam', 12.973, 78.940], ['Anaicut', 12.898, 79.022], ['Latteri', 12.964, 79.030], ['Kaniyambadi', 12.822, 79.066], ['Sathuvachari', 12.938, 79.168]
  ],
  'Villupuram': [
    ['Villupuram', 11.939, 79.493], ['Tindivanam', 12.247, 79.648], ['Gingee', 12.252, 79.417], ['Vikravandi', 12.035, 79.544], ['Thiruvennainallur', 11.839, 79.379], ['Marakkanam', 12.198, 79.953], ['Mundiyampakkam', 11.996, 79.525], ['Koliyanur', 11.937, 79.567], ['Vanur', 12.029, 79.778], ['Kanai', 11.988, 79.398], ['Mailam', 12.128, 79.618]
  ],
  'Virudhunagar': [
    ['Virudhunagar', 9.585, 77.962], ['Sivakasi', 9.449, 77.798], ['Sattur', 9.359, 77.930], ['Rajapalayam', 9.452, 77.553], ['Srivilliputhur', 9.512, 77.632], ['Aruppukkottai', 9.517, 78.099], ['Watrap', 9.648, 77.639], ['Tiruchuli', 9.510, 78.214], ['Kariyapatti', 9.678, 78.098], ['Vembakottai', 9.266, 77.891], ['Narikudi', 9.392, 78.300]
  ],
  // ... (Neighboring States data remains the same)
};


// ==================== COMPREHENSIVE & VERIFIED KNOWN DISTANCES (v4.0) ====================
const knownDist = {
  // ========== MAJOR CHENNAI ROUTES ==========
  'Chennai Central-Coimbatore': 505, 'Chennai Central-Madurai': 462, 'Chennai Central-Trichy': 332, 'Chennai Central-Salem': 340, 'Chennai Central-Tirunelveli': 627, 'Chennai Central-Vellore': 136, 'Chennai Central-Thanjavur': 343, 'Chennai Central-Erode': 395, 'Chennai Central-Dindigul': 420, 'Chennai Central-Pondicherry': 150, 'Chennai Central-Kanyakumari': 710, 'Chennai Central-Ooty': 555, 'Chennai Central-Kodaikanal': 525, 'Chennai Central-Rameswaram': 573, 'Chennai Central-Bangalore': 347, 'Chennai Central-Tirupati': 135, 'Chennai Central-Hosur': 307, 'Kumbakonam-Chennai Central': 296, 'Chennai Central-Nagercoil': 690, 'Chennai Central-Thoothukudi': 600, 'Chennai Central-Karur': 370, 'Chennai Central-Namakkal': 365, 'Chennai Central-Pollachi': 520, 'Chennai Central-Karaikudi': 412, 'Chennai Central-Mahabalipuram': 58, 'Chennai Central-Kanchipuram': 72, 'Chennai Central-Chengalpattu': 58, 'Chennai Central-Thiruvannamalai': 190, 'Chennai Central-Villupuram': 160, 'Chennai Central-Krishnagiri': 255, 'Chennai Central-Dharmapuri': 290, 'Chennai Central-Tiruppur': 450, 'Chennai Central-Kochi': 700, 'Chennai Central-Hyderabad': 630, 'Chennai Central-Mysore': 480, 'Chennai Central-Cuddalore': 185, 'Chennai Central-Ariyalur': 290, 'Chennai Central-Perambalur': 305, 'Chennai Central-Nagapattinam': 340, 'Chennai Central-Sivaganga': 435, 'Chennai Central-Ramanathapuram': 490, 'Chennai Central-Pudukkottai': 395,
  'Chennai Central-Tambaram': 27, 'Chennai Central-Avadi': 22, 'Chennai Central-Velachery': 17, 'Chennai Central-Guindy': 12, 'Chennai Central-T.Nagar': 7, 'Chennai Central-Egmore': 2,

  // ========== COIMBATORE REGION ==========
  'Coimbatore-Madurai': 227, 'Coimbatore-Trichy': 210, 'Coimbatore-Salem': 160, 'Coimbatore-Ooty': 86, 'Coimbatore-Kodaikanal': 175, 'Coimbatore-Erode': 100, 'Coimbatore-Pollachi': 40, 'Coimbatore-Bangalore': 365, 'Coimbatore-Tiruppur': 50, 'Coimbatore-Palani': 95, 'Coimbatore-Dindigul': 190, 'Coimbatore-Mettupalayam': 35, 'Coimbatore-Valparai': 100, 'Coimbatore-Kochi': 190, 'Coimbatore-Munnar': 160, 'Coimbatore-Mysore': 210, 'Coimbatore-Karur': 120, 'Coimbatore-Tirunelveli': 400, 'Coimbatore-Thoothukudi': 370, 'Coimbatore-Nagercoil': 430, 'Coimbatore-Thanjavur': 260, 'Coimbatore-Palakkad': 55, 'Coimbatore-Gobichettipalayam': 75, 'Coimbatore-Sathyamangalam': 70, 'Coimbatore-Avanashi': 45, 'Coimbatore-Sulur': 25, 'Coimbatore-Annur': 30,

  // ========== MADURAI REGION ==========
  'Madurai-Trichy': 138, 'Madurai-Rameswaram': 174, 'Madurai-Kanyakumari': 245, 'Madurai-Kodaikanal': 120, 'Madurai-Dindigul': 63, 'Madurai-Tirunelveli': 156, 'Madurai-Thanjavur': 195, 'Madurai-Nagercoil': 230, 'Madurai-Thoothukudi': 145, 'Madurai-Karaikudi': 85, 'Madurai-Palani': 120, 'Madurai-Sivakasi': 75, 'Madurai-Salem': 230, 'Madurai-Theni': 85, 'Madurai-Ramanathapuram': 115, 'Madurai-Sivaganga': 48, 'Madurai-Virudhunagar': 45, 'Madurai-Pudukkottai': 105, 'Madurai-Melur': 30, 'Madurai-Thirumangalam': 20, 'Madurai-Usilampatti': 40, 'Madurai-Thirupparankundram': 8, 'Madurai-Bodinayakanur': 90, 'Madurai-Periyakulam': 75, 'Madurai-Alanganallur': 16,

  // ========== TRICHY REGION ==========
  'Trichy-Thanjavur': 56, 'Trichy-Salem': 142, 'Trichy-Kumbakonam': 94, 'Trichy-Karur': 75, 'Trichy-Dindigul': 98, 'Trichy-Karaikudi': 100, 'Trichy-Namakkal': 85, 'Trichy-Pudukkottai': 55, 'Trichy-Ariyalur': 65, 'Trichy-Perambalur': 60, 'Trichy-Srirangam': 8, 'Trichy-Musiri': 40, 'Trichy-Manapparai': 40, 'Trichy-Lalgudi': 25, 'Trichy-Thuraiyur': 45,

  // ========== SALEM REGION ==========
  'Salem-Erode': 60, 'Salem-Bangalore': 210, 'Salem-Namakkal': 55, 'Salem-Yercaud': 32, 'Salem-Dharmapuri': 65, 'Salem-Attur': 55, 'Salem-Mettur': 45, 'Salem-Hosur': 165, 'Salem-Krishnagiri': 110, 'Salem-Tiruchengode': 45, 'Salem-Rasipuram': 30, 'Salem-Edappadi': 40, 'Salem-Sankari': 35,

  // ========== SOUTHERN DISTRICTS (Tirunelveli, Kanyakumari, Thoothukudi) ==========
  'Tirunelveli-Kanyakumari': 87, 'Tirunelveli-Nagercoil': 72, 'Tirunelveli-Thoothukudi': 50, 'Tirunelveli-Courtallam': 58, 'Tirunelveli-Tenkasi': 55, 'Tirunelveli-Palayamkottai': 5, 'Tirunelveli-Ambasamudram': 35, 'Tirunelveli-Sankarankovil': 56, 'Tirunelveli-Valliyoor': 45, 'Nagercoil-Kanyakumari': 22, 'Nagercoil-Marthandam': 20, 'Nagercoil-Colachel': 22, 'Thoothukudi-Kovilpatti': 60, 'Thoothukudi-Thiruchendur': 40, 'Thoothukudi-Srivaikundam': 30,

  // ========== CHETTINAD REGION (Sivaganga, Ramanathapuram) ==========
  'Sivaganga-Karaikudi': 45, 'Sivaganga-Madurai': 48, 'Sivaganga-Ramanathapuram': 55, 'Karaikudi-Devakottai': 14, 'Karaikudi-Pudukkottai': 40, 'Karaikudi-Thiruppathur': 15, 'Thiruppathur-Madurai': 60, 'Devakottai-Thiruvadanai': 25, 'Thiruvadanai-R.S.Mangalam': 24, 'Thiruvadanai-Thondi': 15, 'Ramanathapuram-Rameswaram': 55, 'Ramanathapuram-Paramakudi': 35, 'Ramanathapuram-Thoothukudi': 140, 'Paramakudi-Mudukulathur': 20,

  // ========== VELLORE REGION (Vellore, Ranipet, Tirupathur) ==========
  'Vellore-Bangalore': 212, 'Vellore-Tirupati': 115, 'Vellore-Ambur': 52, 'Vellore-Katpadi': 8, 'Vellore-Ranipet': 26, 'Vellore-Arcot': 30, 'Vellore-Gudiyatham': 35, 'Vellore-Thiruvannamalai': 85, 'Ambur-Vaniyambadi': 16, 'Vaniyambadi-Tirupathur': 25, 'Tirupathur-Salem': 135, 'Tirupathur-Dharmapuri': 60, 'Ranipet-Arakkonam': 40, 'Ranipet-Sholinghur': 30,

  // ========== DELTA REGION (Thanjavur, Tiruvarur, Nagapattinam, Mayiladuthurai) ==========
  'Thanjavur-Kumbakonam': 40, 'Thanjavur-Nagapattinam': 80, 'Thanjavur-Pattukkottai': 48, 'Thanjavur-Tiruvarur': 55, 'Kumbakonam-Mayiladuthurai': 30, 'Mayiladuthurai-Sirkazhi': 20, 'Sirkazhi-Chidambaram': 20, 'Nagapattinam-Velankanni': 12, 'Tiruvarur-Mannargudi': 30, 'Mannargudi-Pattukkottai': 30,

  // ========== HILL STATIONS ==========
  'Ooty-Coonoor': 20, 'Ooty-Kotagiri': 30, 'Ooty-Mettupalayam': 50, 'Ooty-Mysore': 125, 'Ooty-Gudalur': 50, 'Kodaikanal-Palani': 65, 'Kodaikanal-Batlagundu': 60, 'Valparai-Pollachi': 65, 'Munnar-Thekkady': 95,

  // ========== PONDICHERRY & VILLUPURAM ==========
  'Pondicherry-Cuddalore': 25, 'Pondicherry-Villupuram': 40, 'Pondicherry-Chidambaram': 65, 'Pondicherry-Tindivanam': 40, 'Villupuram-Tindivanam': 40, 'Villupuram-Gingee': 45, 'Villupuram-Kallakurichi': 55,

  // ========== WESTERN REGION (Tiruppur, Erode, Karur) ==========
  'Tiruppur-Palladam': 16, 'Tiruppur-Avanashi': 14, 'Tiruppur-Udumalaipettai': 70, 'Tiruppur-Dharapuram': 50, 'Tiruppur-Kangeyam': 26, 'Erode-Bhavani': 16, 'Erode-Perundurai': 20, 'Karur-Aravakurichi': 30, 'Karur-Kulithalai': 38,

  // ========== OTHER KEY ROUTES ==========
  'Dharmapuri-Krishnagiri': 50, 'Dharmapuri-Hogenakkal': 48, 'Ariyalur-Chidambaram': 55, 'Tenkasi-Sivagiri': 35, 'Srivilliputhur-Rajapalayam': 12,
  
  // ========== INTER-STATE ==========
  'Bangalore-Mysore': 145, 'Tirupati-Srikalahasti': 40, 'Kochi-Alleppey': 60, 'Palakkad-Thrissur': 70, 'Thiruvananthapuram-Kollam': 70,
};


// ==================== HELPER & CALCULATION FUNCTIONS (v4.0) ====================

const districtNames = Object.keys(districts);
function getDistrictTowns(district) { return districts[district]?.map(t => t[0]) || []; }
function getTownCoords(townName) { for (const dist of Object.values(districts)) { for (const t of dist) { if (t[0] === townName) return [t[1], t[2]]; } } return null; }
function findTownDistrict(townName) { for (const [dist, towns] of Object.entries(districts)) { if (towns.some(t => t[0] === townName)) return dist; } return null; }
function getAllTowns() { const all = []; for (const towns of Object.values(districts)) { for (const t of towns) all.push(t[0]); } return [...new Set(all)].sort(); }

function getDistance(from, to) {
  if (from === to) return 0;

  // Check known distances first (both directions)
  const k1 = knownDist[`${from}-${to}`];
  const k2 = knownDist[`${to}-${from}`];
  if (k1) return k1;
  if (k2) return k2;

  // Get coordinates
  const c1 = getTownCoords(from);
  const c2 = getTownCoords(to);
  if (!c1 || !c2) return null;

  // Haversine formula
  const R = 6371;
  const lat1Rad = c1[0] * Math.PI / 180;
  const lat2Rad = c2[0] * Math.PI / 180;
  const dLat = (c2[0] - c1[0]) * Math.PI / 180;
  const dLon = (c2[1] - c1[1]) * Math.PI / 180;

  const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(lat1Rad) * Math.cos(lat2Rad) *
            Math.sin(dLon / 2) ** 2;
  
  const straightLine = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  // Terrain classification
  const hillStations = [
    'Ooty', 'Coonoor', 'Kotagiri', 'Kodaikanal', 'Valparai', 'Yercaud',
    'Munnar', 'Gudalur', 'Ketti', 'Wellington', 'Lovedale', 'Thekkady',
    'Meghamalai', 'Topslip', 'Yelagiri', 'Javadhu Hills', 'Kolli Hills'
  ];

  const ghatsApproach = [
    'Mettupalayam', 'Sathyamangalam', 'Hasanur', 'Thally', 'Denkanikottai',
    'Batlagundu', 'Cumbum', 'Bodinayakanur', 'Uthamapalayam', 'Courtallam',
    'Palani', 'Pollachi', 'Anaimalai', 'Udumalaipettai'
  ];

  const isHillRoute = hillStations.includes(from) || hillStations.includes(to);
  const isGhatsRoute = ghatsApproach.includes(from) || ghatsApproach.includes(to);

  // ============ FINAL TUNED ROAD FACTORS (v4.2) ============
  let roadFactor;

  if (isHillRoute) {
    // Hill stations - winding ghat roads
    if (straightLine < 15) roadFactor = 1.20;
    else if (straightLine < 30) roadFactor = 1.30;
    else if (straightLine < 60) roadFactor = 1.38;
    else roadFactor = 1.45;
  } 
  else if (isGhatsRoute) {
    // Approaching hills - moderately winding
    if (straightLine < 20) roadFactor = 1.12;
    else if (straightLine < 50) roadFactor = 1.18;
    else roadFactor = 1.22;
  }
  else {
    // ============ PLAINS ROADS - FINAL OPTIMIZED ============
    if (straightLine < 5) {
      // Very short (within town)
      roadFactor = 1.02;
    }
    else if (straightLine < 10) {
      // Short distances
      roadFactor = 1.05;
    }
    else if (straightLine < 20) {
      // ~10-20km straight → ~11-22km road
      roadFactor = 1.08;
    }
    else if (straightLine < 35) {
      // ~20-35km straight → ~22-40km road
      roadFactor = 1.10;
    }
    else if (straightLine < 60) {
      // ~35-60km straight → ~40-70km road
      roadFactor = 1.12;
    }
    else if (straightLine < 100) {
      // ~60-100km straight → ~70-115km road
      roadFactor = 1.15;
    }
    else if (straightLine < 180) {
      // ~100-180km straight → ~115-210km road
      roadFactor = 1.18;
    }
    else if (straightLine < 300) {
      // Long distances
      roadFactor = 1.20;
    }
    else {
      // Very long distances
      roadFactor = 1.22;
    }
  }

  return Math.round(straightLine * roadFactor);
}

// ==================== CONSTANTS & DATA ====================
const PHONE = '9092583626';
const WA_LINK = `https://wa.me/91${PHONE}`;
const PHONE_LINK = `tel:+91${PHONE}`;

const carTypes = [
  // ====== SEDANS (₹14/km One Way | ₹13/km Round Trip) ======
  {
    id: 1, name: 'Suzuki Dzire', type: 'Sedan', rate: 14, roundRate: 13, base: 300, pax: 4, bags: 3,
    image: dzire,
    desc: 'Compact sedan perfect for comfortable city & outstation travel. Spacious boot, smooth ride.',
    color: '#4f46e5',
    features: ['AC', 'GPS', 'Music System', 'USB Charging', 'Airbags'],
    fuelType: 'Petrol/Diesel'
  },
  {
    id: 2, name: 'Suzuki Ciaz', type: 'Sedan', rate: 14, roundRate: 13, base: 300, pax: 4, bags: 3,
    image: ciaz,
    desc: 'Premium sedan with extra legroom and luxurious interiors. Ideal for business & family trips.',
    color: '#6366f1',
    features: ['AC', 'GPS', 'Music System', 'USB Charging', 'Airbags', 'Cruise Control'],
    fuelType: 'Petrol/Diesel'
  },
  {
    id: 3, name: 'Toyota Etios', type: 'Sedan', rate: 14, roundRate: 13, base: 300, pax: 4, bags: 3,
    image: etios,
    desc: 'Reliable Toyota sedan known for durability and comfort. Excellent for long-distance journeys.',
    color: '#3b82f6',
    features: ['AC', 'GPS', 'Music System', 'USB Charging', 'Airbags'],
    fuelType: 'Petrol/Diesel'
  },

  // ====== SUVs (₹19/km One Way | ₹18/km Round Trip) ======
  {
    id: 4, name: 'Suzuki Ertiga', type: 'SUV', rate: 19, roundRate: 18, base: 300, pax: 7, bags: 4,
    image: ertica,
    desc: 'Versatile 7-seater MPV with excellent fuel efficiency. Perfect for family outings & group travel.',
    color: '#059669',
    features: ['AC', 'GPS', 'Music System', 'USB Charging', '3-Row Seating', 'Airbags'],
    fuelType: 'Petrol/CNG'
  },
  {
    id: 5, name: 'Kia Carens', type: 'SUV', rate: 19, roundRate: 18, base: 300, pax: 7, bags: 4,
    image: carens,
    desc: 'Modern 7-seater with premium features and stylish design. Loaded with tech & comfort.',
    color: '#0891b2',
    features: ['AC', 'GPS', 'Touchscreen', 'USB Charging', '3-Row Seating', 'Airbags', 'Sunroof'],
    fuelType: 'Petrol/Diesel'
  },
  {
    id: 6, name: 'Toyota Innova', type: 'SUV', rate: 19, roundRate: 18, base: 300, pax: 7, bags: 5,
    image: innova,
    desc: 'India\'s most trusted MPV. Robust, spacious, and built for long comfortable highway rides.',
    color: '#7c3aed',
    features: ['AC', 'GPS', 'Music System', 'USB Charging', '3-Row Seating', 'Airbags'],
    fuelType: 'Diesel'
  },
  {
    id: 7, name: 'Mahindra Xylo', type: 'SUV', rate: 19, roundRate: 18, base: 300, pax: 8, bags: 5,
    image: xylo,
    desc: 'Rugged and powerful SUV with maximum space. Great for large families and heavy luggage.',
    color: '#a855f7',
    features: ['AC', 'GPS', 'Music System', 'USB Charging', '3-Row Seating', 'Power Steering'],
    fuelType: 'Diesel'
  },

  // ====== PREMIUM (₹22/km One Way | ₹21/km Round Trip) ======
  {
    id: 8, name: 'Innova Crysta', type: 'Premium', rate: 22, roundRate: 21, base: 300, pax: 7, bags: 5,
    image: crysta,
    desc: 'The ultimate premium ride. Captain seats, automatic climate control, and first-class comfort.',
    color: '#dc2626',
    features: ['AC', 'GPS', 'Touchscreen', 'USB Charging', 'Captain Seats', 'Airbags', 'Auto Climate', 'Leather Seats'],
    fuelType: 'Diesel'
  },
];
const topCities = [
  {
    name: 'Chennai', tag: 'Capital City', desc: 'Gateway of South India — Marina Beach, ancient temples, bustling IT corridors, and vibrant culture.',
    image: chennai
  },
  {
    name: 'Madurai', tag: 'Temple City', desc: 'Home to the majestic Meenakshi Amman Temple, rich history, and authentic South Indian cuisine.',
    image: madurai
  },
  {
    name: 'Coimbatore', tag: 'Manchester of South', desc: 'Industrial hub surrounded by Western Ghats, gateway to Ooty and hill stations.',
    image: coimbatore
  },
  {
    name: 'Ooty', tag: 'Queen of Hills', desc: 'Breathtaking Nilgiri hills, tea gardens, toy train, and pleasant weather all year round.',
    image: ooty
  },
  {
    name: 'Pondicherry', tag: 'French Riviera', desc: 'Charming French colonial architecture, serene beaches, Auroville, and vibrant nightlife.',
    image: pondicherry
  },
  {
    name: 'Kanyakumari', tag: "Land's End", desc: 'Where three oceans meet — stunning sunrise & sunset, Vivekananda Rock Memorial.',
    image: kanniyakumari
  },
  {
    name: 'Rameswaram', tag: 'Holy Island', desc: 'Sacred pilgrimage destination, Pamban Bridge, pristine beaches, and temple architecture.',
    image: rameshwaram
  },
  {
    name: 'Kodaikanal', tag: 'Princess of Hills', desc: 'Misty hills, serene lakes, lush forests, waterfalls, and the perfect romantic retreat.',
    image: kodaikkanal
  },
  {
    name: 'Trichy', tag: 'Rock Fort City', desc: 'Ancient Rock Fort temple, Srirangam island temple, and rich Chola dynasty heritage.',
    image: trichy
  },
  {
    name: 'Thanjavur', tag: 'Rice Bowl of TN', desc: 'UNESCO World Heritage Big Temple, classical arts, Saraswathi Mahal Library.',
    image: thanjavur
  },
  {
    name: 'Vellore', tag: 'Fort City', desc: 'Historic Vellore Fort, Golden Temple, premier medical institutions.',
    image: vellore
  },
  {
    name: 'Salem', tag: 'Steel City', desc: 'Surrounded by hills, gateway to Yercaud, known for steel, mangoes, and textiles.',
    image: salem
  },
];

const popularRoutes = [
  { from: 'Chennai', to: 'Bangalore', dist: 347 }, { from: 'Madurai', to: 'Rameswaram', dist: 174 }, { from: 'Chennai', to: 'Pondicherry', dist: 150 },
  { from: 'Coimbatore', to: 'Ooty', dist: 86 },
  { from: 'Chennai', to: 'Madurai', dist: 462 },
  { from: 'Madurai', to: 'Kodaikanal', dist: 120 },
  { from: 'Trichy', to: 'Chennai', dist: 332 }, { from: 'Chennai', to: 'Tirupati', dist: 135 },


];

const testimonials = [
  { name: 'Rajesh Kumar', city: 'Chennai', stars: 5, text: 'Excellent service! Professional driver and clean car. Chennai to Bangalore trip was incredibly smooth. Highly recommended MithraTaxi!' },
  { name: 'Priya Sharma', city: 'Madurai', stars: 5, text: 'Wonderful Rameswaram pilgrimage! Driver was punctual and very courteous. Comfortable ride at a great price.' },
  { name: 'Mohammed Ali', city: 'Coimbatore', stars: 5, text: 'Best taxi service in Tamil Nadu! Ooty trip was amazing. Very fair pricing and well-maintained vehicle.' },
  { name: 'Lakshmi Devi', city: 'Trichy', stars: 5, text: 'Booked for a family trip. Smooth booking, clean car, and the driver was extremely helpful. 5 stars!' },
  { name: 'Suresh Babu', city: 'Salem', stars: 5, text: 'Regular business traveler with MithraTaxi. Always reliable, always professional. Never disappoints!' },
  { name: 'Anitha Rajan', city: 'Vellore', stars: 5, text: 'Round trip to Chennai for a hospital visit. Driver was caring and patient. Felt very safe. Thank you MithraTaxi!' },
];

const faqs = [
  { q: 'How do I book a taxi with MithraTaxi?', a: 'You can book through our website, call us at +91 9500195158, or WhatsApp us anytime. We confirm your booking within minutes!' },
  { q: 'What payment options are available?', a: 'We accept Cash, UPI (Google Pay, PhonePe, Paytm), Credit/Debit Cards, Net Banking, and corporate billing options.' },
  { q: 'Do you provide outstation taxi services?', a: 'Yes! We cover all of Tamil Nadu and neighboring states including Karnataka, Kerala, Andhra Pradesh, and Telangana.' },
  { q: 'Is there a minimum kilometer charge?', a: 'One-way trips: minimum 130 km. Round trips: minimum 250 km per day. Local packages: 4hr/40km, 8hr/80km, 12hr/120km.' },
  { q: 'Can I cancel my booking?', a: 'Free cancellation up to 4 hours before your scheduled trip. Within 4 hours, a nominal cancellation fee of ₹200 may apply.' },
  { q: 'Do you offer airport pickup and drop?', a: 'Yes! Airport transfers available at Chennai, Coimbatore, Madurai, Trichy, and Tirupati airports. Driver tracks your flight and meets you at arrivals.' },
  { q: 'Are your drivers verified and safe?', a: '100% verified! All drivers undergo thorough background checks, hold valid commercial licenses, and are trained in safety and customer service.' },
  { q: 'Is night travel available?', a: 'Absolutely! We operate 24/7, 365 days a year. Night charges (10 PM to 6 AM) of ₹150 flat are applicable.' },
];

// ==================== HOOKS ====================
function useScrollAnim() {
  const [vis, setVis] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVis(true); }, { threshold: 0.08 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, vis];
}

function useCounter(end, dur, go) {
  const [c, setC] = useState(0);
  useEffect(() => {
    if (!go) return;
    let s = null;
    const a = (t) => { if (!s) s = t; const p = Math.min((t - s) / dur, 1); setC(Math.floor(p * end)); if (p < 1) requestAnimationFrame(a); };
    requestAnimationFrame(a);
  }, [end, dur, go]);
  return c;
}

// ==================== LOCATION PICKER COMPONENT ====================
const LocationPicker = ({ label, emoji, selectedDistrict, selectedTown, onDistrictChange, onTownChange, excludeTown }) => {
  const towns = selectedDistrict ? getDistrictTowns(selectedDistrict) : [];

  return (
    <div className="location-picker">
      <label>{emoji} {label}</label>
      <div className="lp-selects">
        <select
          value={selectedDistrict}
          onChange={(e) => { onDistrictChange(e.target.value); onTownChange(''); }}
          className="lp-district"
        >
          <option value="">🗺️ Select District</option>
          {districtNames.map(d => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
        <select
          value={selectedTown}
          onChange={(e) => onTownChange(e.target.value)}
          disabled={!selectedDistrict}
          className="lp-town"
        >
          <option value="">📍 Select Town</option>
          {towns.filter(t => t !== excludeTown).map(t => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

// ==================== COMPONENTS ====================

// const TopBar = () => (
//   <div className="topbar">
//     <div className="topbar-inner">
//       <div className="topbar-left">
//         <span>📧 booking@mithrataxi.com</span>
//         <span>📍 All Over Tamil Nadu</span>
//       </div>
//       <div className="topbar-right">
//         <a href={PHONE_LINK}>📞 +91 {PHONE}</a>
//         <span>⏰ 24/7 Service</span>
//       </div>
//     </div>
//   </div>
// );

const Navbar = ({ scrolled }) => {
  const [open, setOpen] = useState(false);
  const go = (id) => { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); setOpen(false); };
  const links = [
    ['hero', 'Home'], ['services', 'Services'], ['fleet', 'Fleet'], ['cities', 'Cities'],
    ['routes', 'Routes'], ['fare', 'Fare Calculator'], ['why', 'Why Us'],
    ['testimonials', 'Reviews'], ['faq', 'FAQ'], ['contact', 'Contact']
  ];
  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-inner">
        <div className="logo" onClick={() => go('hero')}>
        <img src={logo} alt="ManiTaxi Logo" className="logo-img" />
          <span className="logo-text">Mithra<span className="logo-accent">Taxi</span></span>
        </div>
        <div className={`nav-links${open ? ' open' : ''}`}>
          {links.map(([id, label]) => (
            <button key={id} className="nav-link" onClick={() => go(id)}>{label}</button>
          ))}
          <a href={PHONE_LINK} className="nav-cta-mobile">📞 Call Now</a>
        </div>
        <a href={PHONE_LINK} className="nav-cta">📞 Book Now</a>
        <button className="hamburger" onClick={() => setOpen(!open)} aria-label="Menu">
          <span style={open ? { transform: 'rotate(45deg) translate(5px,5px)' } : {}} />
          <span style={open ? { opacity: 0 } : {}} />
          <span style={open ? { transform: 'rotate(-45deg) translate(6px,-6px)' } : {}} />
        </button>
      </div>
      {open && <div className="nav-overlay" onClick={() => setOpen(false)} />}
    </nav>
  );
};

const HeroSection = () => {
  const [trip, setTrip] = useState('oneway');
  const [fromDist, setFromDist] = useState('');
  const [fromTown, setFromTown] = useState('');
  const [toDist, setToDist] = useState('');
  const [toTown, setToTown] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [car, setCar] = useState('');
  const [result, setResult] = useState(null);
  const [typed, setTyped] = useState('');
  const full = 'Your Trusted Ride Across Tamil Nadu';

  useEffect(() => {
    let i = 0;
    const t = setInterval(() => { setTyped(full.slice(0, ++i)); if (i >= full.length) clearInterval(t); }, 55);
    return () => clearInterval(t);
  }, []);

  const calc = () => {
    if (!fromTown || !toTown || !car) { alert('Please select From Town, To Town, and Car Type'); return; }
    if (fromTown === toTown) { alert('Pickup and drop cannot be the same'); return; }
    const dist = getDistance(fromTown, toTown);
    if (!dist) { alert('Unable to calculate distance. Please call us!'); return; }
    const c = carTypes.find(x => x.name === car);
    const isRound = trip === 'roundtrip';
    const activeRate = isRound ? c.roundRate : c.rate;
    const d = isRound ? dist * 2 : dist;
    const fare = d * activeRate + c.base;
    setResult({ dist: d, fare, car: c, trip, from: fromTown, to: toTown, ow: dist, activeRate });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-banner"/>
      <div className="hero-blob hero-blob-1" />
      <div className="hero-blob hero-blob-2" />
      <div className="hero-blob hero-blob-3" />
      <div className="hero-particles">
        {[...Array(15)].map((_, i) => <div key={i} className="particle" style={{
          left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 5}s`, animationDuration: `${4 + Math.random() * 4}s`,
          background: ['#6366f1', '#a855f7', '#f59e0b', '#0891b2', '#059669'][i % 5]
        }} />)}
      </div>
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-badge">🏆 #1 Rated Taxi Service in Tamil Nadu</div>
          <h1 className="hero-title">{typed}<span className="cursor">|</span></h1>
          <p className="hero-sub">Safe • Affordable • Comfortable — Book your ride in seconds across 500+ towns in Tamil Nadu with MithraTaxi's premium fleet.</p>
          <div className="hero-stats-row">
            <div className="hero-stat"><span className="hs-num">50K+</span><span className="hs-lab">Happy Rides</span></div>
            <div className="hero-stat"><span className="hs-num">500+</span><span className="hs-lab">Towns</span></div>
            <div className="hero-stat"><span className="hs-num">38</span><span className="hs-lab">Districts</span></div>
            <div className="hero-stat"><span className="hs-num">24/7</span><span className="hs-lab">Support</span></div>
          </div>
        </div>
        <div className="hero-form-wrapper">
          <div className="booking-form">
            <h3 className="bf-title">🚖 Book Your Ride Now</h3>
            <div className="trip-toggle">
              <button className={`tt-btn${trip === 'oneway' ? ' active' : ''}`} onClick={() => setTrip('oneway')}>➡️ One Way</button>
              <button className={`tt-btn${trip === 'roundtrip' ? ' active' : ''}`} onClick={() => setTrip('roundtrip')}>🔄 Round Trip</button>
            </div>
            <div className="bf-locations">
              <LocationPicker
                label="Pickup Location" emoji="🟢"
                selectedDistrict={fromDist} selectedTown={fromTown}
                onDistrictChange={setFromDist} onTownChange={setFromTown}
                excludeTown={null}
              />
              <LocationPicker
                label="Drop Location" emoji="🔴"
                selectedDistrict={toDist} selectedTown={toTown}
                onDistrictChange={setToDist} onTownChange={setToTown}
                excludeTown={fromTown}
              />
            </div>
            <div className="bf-grid">
              <div className="bf-group">
                <label>📅 Travel Date</label>
                <input type="date" value={date} onChange={e => setDate(e.target.value)} min={new Date().toISOString().split('T')[0]} />
              </div>
              <div className="bf-group">
                <label>⏰ Pickup Time</label>
                <input type="time" value={time} onChange={e => setTime(e.target.value)} />
              </div>
            </div>
            <div className="bf-group bf-full">
              <label>🚗 Select Car</label>
              <select value={car} onChange={e => setCar(e.target.value)}>
                <option value="">Choose Vehicle</option>
                <optgroup label="🚙 Sedan — ₹14/km (One Way) | ₹13/km (Round Trip)">
                  {carTypes.filter(c => c.type === 'Sedan').map(c => (
                    <option key={c.id} value={c.name}>{c.name} — {c.pax} Seats</option>
                  ))}
                </optgroup>
                <optgroup label="🚐 SUV — ₹19/km (One Way) | ₹18/km (Round Trip)">
                  {carTypes.filter(c => c.type === 'SUV').map(c => (
                    <option key={c.id} value={c.name}>{c.name} — {c.pax} Seats</option>
                  ))}
                </optgroup>
                <optgroup label="🏎️ Premium — ₹22/km (One Way) | ₹21/km (Round Trip)">
                  {carTypes.filter(c => c.type === 'Premium').map(c => (
                    <option key={c.id} value={c.name}>{c.name} — {c.pax} Seats</option>
                  ))}
                </optgroup>
              </select>
            </div>
            <button className="glow-btn" onClick={calc}>⚡ Get Instant Fare Quote</button>
            {result && (
              <div className="fare-result">
                <div className="fr-route">{result.from} → {result.to}</div>
                <div className="fr-tags">
                  <span className="fr-tag">{result.trip === 'roundtrip' ? '🔄 Round Trip' : '➡️ One Way'}</span>
                  <span className="fr-tag">📏 {result.ow}km{result.trip === 'roundtrip' ? ' × 2' : ''}</span>
                  <span className="fr-tag">{result.car.type}</span>
                  <span className="fr-tag">{result.car.name}</span>
                </div>
                <div className="fr-fare">₹{result.fare.toLocaleString()}</div>
                <div className="fr-break">
                  ({result.dist}km × ₹{result.activeRate}/km + ₹{result.car.base} base fare)
                </div>
                <div className="fr-rate-info">
                  {result.trip === 'roundtrip'
                    ? `✅ Round trip rate applied: ₹${result.car.roundRate}/km (Save ₹${result.dist * (result.car.rate - result.car.roundRate)}!)`
                    : `💡 Book round trip for ₹${result.car.roundRate}/km and save!`}
                </div>
                <div className="fr-actions">
                  <a href={PHONE_LINK} className="fr-btn fr-btn-call">📞 Call to Book</a>
                  <a href={`${WA_LINK}?text=Hi! I want to book *${result.car.name}* (${result.car.type})%0A📍 ${result.from} → ${result.to}%0A🔄 ${result.trip === 'roundtrip' ? 'Round Trip' : 'One Way'}%0A📏 ${result.dist}km%0A💰 Fare: ₹${result.fare}%0A📅 Date: ${date || 'Flexible'}`} className="fr-btn fr-btn-wa" target="_blank" rel="noreferrer">💬 WhatsApp</a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="hero-wave"><svg viewBox="0 0 1440 100" preserveAspectRatio="none"><path d="M0,40 C360,100 720,0 1080,50 C1260,75 1380,60 1440,40 L1440,100 L0,100Z" fill="#ffffff" /></svg></div>
    </section>
  );
};

const ServicesSection = () => {
  const [ref, vis] = useScrollAnim();
  const [activeIndex, setActiveIndex] = useState(-1);
  const cardsRef = useRef([]);

  const data = [
    { icon:'🛣️',title:'One Way Taxi',
      desc:'Pay only for one way — no return charges! Travel between any towns across Tamil Nadu at the lowest per-km rates.',
      color:'#059669',
      bg:oneway
    },
    { icon:'🔄',title:'Round Trip Taxi',
      desc:'Best inclusive rates for round trips. Driver bata, toll, parking — everything covered in one transparent price.',
      color:'#4f46e5',
      bg:roundtrip
    },
    { icon:'✈️',title:'Airport Transfer',
      desc:'Reliable airport pickups & drops at Chennai, Coimbatore, Madurai & Trichy airports. Flight tracking included.',
      color:'#d97706',
      bg:airport
    },
    { icon:'🏙️',title:'Local City Taxi',
      desc:'Hourly packages for city travel — 4hr/40km, 8hr/80km, 12hr/120km. Perfect for shopping, meetings & sightseeing.',
      color:'#dc2626',
      bg:local
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const screenCenter = window.innerHeight / 2;
      
      let closestIndex = -1;
      let closestDistance = Infinity;
  
      cardsRef.current.forEach((card, index) => {
        if (card) {
          const rect = card.getBoundingClientRect();
          const cardCenter = rect.top + rect.height / 2;
          const distance = Math.abs(screenCenter - cardCenter);
          
          // Card must be mostly visible (at least 60% in view)
          const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
          const visiblePercent = visibleHeight / rect.height;
          
          // Only consider if card is 60%+ visible AND closest to center
          if (visiblePercent >= 0.6 && distance < closestDistance) {
            // Card must be within middle 35% of screen
            if (distance < window.innerHeight * 0.35) {
              closestDistance = distance;
              closestIndex = index;
            }
          }
        }
      });
  
      setActiveIndex(closestIndex);
    };
  
    // Throttle scroll events for better performance
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
  
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    handleScroll();
  
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <section id="services" className="section" ref={ref}>
      <div className="container">
        <div className={`section-header${vis?' anim':''}`}>
          <span className="section-badge">What We Do</span>
          <h2 className="section-title">Our <span className="grad-text">Services</span></h2>
          <p className="section-sub">Complete taxi solutions for every travel need across 500+ towns in Tamil Nadu</p>
        </div>
        <div className="services-grid">
          {data.map((s, i) => (
            <div 
              key={i} 
              ref={el => cardsRef.current[i] = el}
              className={`service-card${vis ? ' anim' : ''}${activeIndex === i ? ' sc-active' : ''}`} 
              style={{animationDelay:`${i * 0.15}s`}}
            >
              <div className="sc-content" style={{backgroundImage:`url(${s.bg})`}}>
                <div className="sc-icon-wrap" style={{background:`${s.color}20`,borderColor:`${s.color}50`}}>
                  <span className="sc-icon">{s.icon}</span>
                </div>
                <h3 className="sc-title">{s.title}</h3>
                <p className="sc-desc">{s.desc}</p>
                <a href={PHONE_LINK} className="sc-btn" style={{color:s.color,borderColor:`${s.color}40`}}>Book Now →</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const HowItWorks = () => {
  const [ref, vis] = useScrollAnim();
  const steps = [
    { n: '01', icon: '📱', title: 'Select District & Town', desc: 'Pick your district, then choose your pickup & drop town from 500+ options', color: '#6366f1' },
    { n: '02', icon: '💰', title: 'Get Instant Quote', desc: 'See transparent pricing instantly — no hidden fees, no surprises', color: '#a855f7' },
    { n: '03', icon: '🚖', title: 'Enjoy Your Ride', desc: 'Verified driver arrives on time. Sit back & enjoy a safe, comfortable journey', color: '#f59e0b' },
  ];
  return (
    <section className="section section-alt" ref={ref}>
      <div className="container">
        <div className={`section-header${vis ? ' anim' : ''}`}>
          <span className="section-badge">Mithra Process</span>
          <h2 className="section-title">How It <span className="grad-text">Works</span></h2>
          <p className="section-sub">Book your ride in 3 simple steps</p>
        </div>
        <div className="steps-grid">
          {steps.map((s, i) => (
            <div key={i} className={`step-card${vis ? ' anim' : ''}`} style={{ animationDelay: `${i * 0.2}s` }}>
              <div className="step-num" style={{ color: `${s.color}20` }}>{s.n}</div>
              <div className="step-icon-wrap" style={{ background: `${s.color}10`, boxShadow: `0 8px 30px ${s.color}15` }}>
                <span className="step-icon">{s.icon}</span>
              </div>
              <h3 className="step-title">{s.title}</h3>
              <p className="step-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const FleetSection = () => {
  const [ref, vis] = useScrollAnim();
  const [filter, setFilter] = useState('All');
  const types = ['All', 'Sedan', 'SUV', 'Premium'];
  const filtered = filter === 'All' ? carTypes : carTypes.filter(c => c.type === filter);

  return (
    <section id="fleet" className="section" ref={ref}>
      <div className="container">
        <div className={`section-header${vis ? ' anim' : ''}`}>
          <span className="section-badge">Our 8 Vehicles</span>
          <h2 className="section-title">Choose Your <span className="grad-text">Ride</span></h2>
          <p className="section-sub">Well-maintained, AC vehicles — different rates for one-way & round trips</p>
        </div>

        {/* Pricing Summary */}
        {/* <div className={`pricing-summary${vis ? ' anim' : ''}`}>
          <div className="ps-card ps-sedan">
            <span className="ps-type">🚙 Sedan</span>
            <div className="ps-rates">
              <span className="ps-rate">₹14<small>/km</small></span>
              <span className="ps-label">One Way</span>
            </div>
            <div className="ps-rates">
              <span className="ps-rate ps-round">₹13<small>/km</small></span>
              <span className="ps-label">Round Trip</span>
            </div>
            <span className="ps-cars">Dzire • Ciaz • Etios</span>
          </div>
          <div className="ps-card ps-suv">
            <span className="ps-type">🚐 SUV</span>
            <div className="ps-rates">
              <span className="ps-rate">₹19<small>/km</small></span>
              <span className="ps-label">One Way</span>
            </div>
            <div className="ps-rates">
              <span className="ps-rate ps-round">₹18<small>/km</small></span>
              <span className="ps-label">Round Trip</span>
            </div>
            <span className="ps-cars">Ertiga • Carens • Innova • Xylo</span>
          </div>
          <div className="ps-card ps-premium">
            <span className="ps-type">🏎️ Premium</span>
            <div className="ps-rates">
              <span className="ps-rate">₹22<small>/km</small></span>
              <span className="ps-label">One Way</span>
            </div>
            <div className="ps-rates">
              <span className="ps-rate ps-round">₹21<small>/km</small></span>
              <span className="ps-label">Round Trip</span>
            </div>
            <span className="ps-cars">Innova Crysta</span>
          </div>
        </div> */}

        {/* Filter Buttons */}
        <div className={`fleet-filter${vis ? ' anim' : ''}`}>
          {types.map(t => (
            <button key={t} className={`ff-btn${filter === t ? ' active' : ''}`} onClick={() => setFilter(t)}>
              {t === 'All' ? '🚗 All Cars' : t === 'Sedan' ? '🚙 Sedans' : t === 'SUV' ? '🚐 SUVs' : '🏎️ Premium'}
              <span className="ff-count">{t === 'All' ? 8 : carTypes.filter(c => c.type === t).length}</span>
            </button>
          ))}
        </div>

        {/* Car Cards */}
        <div className="fleet-grid">
          {filtered.map((c, i) => (
            <div key={c.id} className={`fleet-card${vis ? ' anim' : ''}`} style={{ animationDelay: `${i * 0.1}s` }}>
              <div className="fc-ribbon" style={{ background: c.color }}>{c.type}</div>
              <div className="fc-img-wrap">
                <img src={c.image} alt={c.name} className="fc-img" loading="lazy" />
              </div>
              <div className="fc-body">
                <div className="fc-type-badge" style={{ color: c.color, background: `${c.color}10`, borderColor: `${c.color}30` }}>
                  {c.type === 'Sedan' ? '🚙' : c.type === 'SUV' ? '🚐' : '🏎️'} {c.type}
                </div>
                <h3 className="fc-name">{c.name}</h3>
                <p className="fc-desc">{c.desc}</p>

                <div className="fc-specs">
                  <div className="fc-spec"><span className="fc-spec-icon">👤</span><span>{c.pax} Seats</span></div>
                  <div className="fc-spec"><span className="fc-spec-icon">🧳</span><span>{c.bags} Bags</span></div>
                  <div className="fc-spec"><span className="fc-spec-icon">⛽</span><span>{c.fuelType}</span></div>
                  <div className="fc-spec"><span className="fc-spec-icon">❄️</span><span>AC</span></div>
                </div>

                <div className="fc-features-list">
                  {c.features.slice(0, 4).map((f, fi) => (
                    <span key={fi} className="fc-feature-tag">✓ {f}</span>
                  ))}
                  {c.features.length > 4 && <span className="fc-feature-tag fc-more">+{c.features.length - 4} more</span>}
                </div>

                <div className="fc-pricing-compact">
                  <div className="fc-price-pill">
                    <span className="fc-pill-label">➡️ One Way</span>
                    <span className="fc-pill-rate" style={{ color: c.color }}>₹{c.rate}<small>/km</small></span>
                  </div>
                  <div className="fc-price-pill fc-pill-round">
                    <span className="fc-pill-label">🔄 Round Trip</span>
                    <span className="fc-pill-rate" style={{ color: '#059669' }}>₹{c.roundRate}<small>/km</small></span>
                  </div>
                  <div className="fc-price-pill fc-pill-base">
                    <span className="fc-pill-label">📋 Base</span>
                    <span className="fc-pill-rate">₹{c.base}</span>
                  </div>
                </div>

                <div className="fc-book-btns">
                  <a href={PHONE_LINK} className="fc-book" style={{ background: c.color }}>📞 Book Now</a>
                  <a href={`${WA_LINK}?text=Hi! I want to book *${c.name}* (${c.type}). Please share availability.`} className="fc-book fc-book-wa" target="_blank" rel="noreferrer">💬 WhatsApp</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const CitiesSection = () => {
  const [ref, vis] = useScrollAnim();
  return (
    <section id="cities" className="section section-alt" ref={ref}>
      <div className="container">
        <div className={`section-header${vis ? ' anim' : ''}`}>
          <span className="section-badge">We Cover All TN</span>
          <h2 className="section-title">Top <span className="grad-text">Destinations</span></h2>
          <p className="section-sub">Explore the best of Tamil Nadu with MithraTaxi — covering all 38 districts & 500+ towns</p>
        </div>
        <div className="cities-grid">
          {topCities.map((c, i) => (
            <div key={i} className={`city-card${vis ? ' anim' : ''}`} style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="city-img-wrap">
                <img src={c.image} alt={c.name} className="city-img" loading="lazy" />
                <div className="city-overlay"><span className="city-tag">{c.tag}</span></div>
              </div>
              <div className="city-body">
                <h3 className="city-name">{c.name}</h3>
                <p className="city-desc">{c.desc}</p>
                <a href={PHONE_LINK} className="city-book">Book Taxi to {c.name} →</a>
              </div>
            </div>
          ))}
        </div>
        {/* District Coverage Section */}
        {/* <div className={`district-coverage${vis?' anim':''}`} style={{animationDelay:'0.5s'}}>
          <h3 className="dc-title">🗺️ All 38 Districts Covered</h3>
          <div className="dc-grid">
            {districtNames.filter(d => !['Bangalore (Karnataka)','Pondicherry (UT)','Kerala','Andhra Pradesh','Telangana'].includes(d)).map((d,i) => (
              <div key={i} className="dc-item">
                <span className="dc-dot"/>
                <span className="dc-name">{d}</span>
                <span className="dc-count">{districts[d].length} towns</span>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
};

const RoutesSection = () => {
  const [ref, vis] = useScrollAnim();
  return (
    <section id="routes" className="section" ref={ref}>
      <div className="container">
        <div className={`section-header${vis ? ' anim' : ''}`}>
          <span className="section-badge">Popular Trips</span>
          <h2 className="section-title">Most Booked <span className="grad-text">Routes</span></h2>
          <p className="section-sub">Top taxi routes with transparent, fixed pricing</p>
        </div>
        <div className="routes-grid">
          {popularRoutes.map((r, i) => (
            <div key={i} className={`route-card${vis ? ' anim' : ''}`} style={{ animationDelay: `${i * 0.07}s` }}>
              <div className="rc-cities">
                <span className="rc-from">{r.from}</span>
                <span className="rc-arrow">✈️</span>
                <span className="rc-to">{r.to}</span>
              </div>
              <div className="rc-info">
                <span>📏 {r.dist} km</span>
                <span className="rc-price">From <b>₹{(r.dist * 14 + 300).toLocaleString()}</b></span>
              </div>
              <a href={PHONE_LINK} className="rc-book">Book Now →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const FareCalculator = () => {
  const [ref, vis] = useScrollAnim();
  const [fromDist, setFromDist] = useState('');
  const [fromTown, setFromTown] = useState('');
  const [toDist, setToDist] = useState('');
  const [toTown, setToTown] = useState('');
  const [trip, setTrip] = useState('oneway');
  const [results, setResults] = useState(null);

  const calc = () => {
    if (!fromTown || !toTown) { alert('Please select both pickup & drop towns'); return; }
    if (fromTown === toTown) { alert('Towns cannot be the same'); return; }
    const dist = getDistance(fromTown, toTown);
    if (!dist) { alert('Unable to calculate. Please call us!'); return; }
    const isRound = trip === 'roundtrip';
    const d = isRound ? dist * 2 : dist;
    setResults({
      list: carTypes.map(c => ({
        ...c,
        total: d,
        activeRate: isRound ? c.roundRate : c.rate,
        fare: d * (isRound ? c.roundRate : c.rate) + c.base,
        savedPerKm: isRound ? c.rate - c.roundRate : 0,
        totalSaved: isRound ? d * (c.rate - c.roundRate) : 0,
      })),
      dist: d, ow: dist, from: fromTown, to: toTown, trip
    });
  };

  const swap = () => {
    const td = fromDist, tt = fromTown;
    setFromDist(toDist); setFromTown(toTown);
    setToDist(td); setToTown(tt);
  };

  return (
    <section id="fare" className="section section-alt" ref={ref}>
      <div className="container">
        <div className={`section-header${vis ? ' anim' : ''}`}>
          <span className="section-badge">Compare Prices</span>
          <h2 className="section-title">Fare <span className="grad-text">Calculator</span></h2>
          <p className="section-sub">Select district → town and compare fares across all car types</p>
        </div>
        <div className="fare-calc">
          <div className="fare-toggle">
            <button className={trip === 'oneway' ? 'active' : ''} onClick={() => setTrip('oneway')}>➡️ One Way</button>
            <button className={trip === 'roundtrip' ? 'active' : ''} onClick={() => setTrip('roundtrip')}>🔄 Round Trip</button>
          </div>
          <div className="fare-pickers">
            <div className="fare-picker-col">
              <LocationPicker
                label="From" emoji="🟢"
                selectedDistrict={fromDist} selectedTown={fromTown}
                onDistrictChange={setFromDist} onTownChange={setFromTown}
                excludeTown={null}
              />
            </div>
            <button className="fare-swap-btn" onClick={swap} title="Swap">⇄</button>
            <div className="fare-picker-col">
              <LocationPicker
                label="To" emoji="🔴"
                selectedDistrict={toDist} selectedTown={toTown}
                onDistrictChange={setToDist} onTownChange={setToTown}
                excludeTown={fromTown}
              />
            </div>
          </div>
          <button className="glow-btn fare-go" onClick={calc}>⚡ Calculate Fare for All Cars</button>

          {results && (
            <div className="fare-results">
              <div className="fare-route-info">
                <h4>{results.from} → {results.to}</h4>
                <p>{results.trip === 'roundtrip' ? `Round Trip • ${results.ow}km × 2 = ${results.dist}km` : `One Way • ${results.dist}km`}</p>
              </div>
              <div className="fare-cards">
                {results.list.map(r => (
                  <div key={r.id} className="fare-card-item" style={{ borderTopColor: r.color }}>
                    <img src={r.image} alt={r.name} className="fci-img" />
                    <div className="fci-type" style={{ color: r.color }}>{r.type}</div>
                    <div className="fci-name">{r.name}</div>
                    <div className="fci-fare" style={{ color: r.color }}>₹{r.fare.toLocaleString()}</div>
                    <div className="fci-detail">₹{r.activeRate}/km × {r.total}km + ₹{r.base}</div>
                    <div className="fci-features">👤{r.pax} 🧳{r.bags}</div>
                    {r.totalSaved > 0 && (
                      <div className="fci-saved">💚 Saving ₹{r.totalSaved.toLocaleString()}!</div>
                    )}
                    <a href={`${WA_LINK}?text=Hi! Book *${r.name}*: ${results.from} → ${results.to} (${results.trip}). Fare: ₹${r.fare}`} className="fci-book" style={{ background: r.color }} target="_blank" rel="noreferrer">Book ₹{r.fare.toLocaleString()}</a>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

const StatsSection = () => {
  const [ref, vis] = useScrollAnim();
  const s1 = useCounter(50000, 2000, vis), s2 = useCounter(500, 2000, vis), s3 = useCounter(38, 2000, vis), s4 = useCounter(8, 2000, vis);
  const stats = [
    { val: `${s1.toLocaleString()}+`, label: 'Happy Customers', icon: '😊', color: '#6366f1' },
    { val: `${s2}+`, label: 'Towns Covered', icon: '📍', color: '#a855f7' },
    { val: `${s3}`, label: 'Districts', icon: '🗺️', color: '#f59e0b' },
    { val: `${s4}+`, label: 'Years Experience', icon: '🏆', color: '#059669' },
  ];
  return (
    <section className="stats-section" ref={ref}>
      <div className="container">
        <div className="stats-grid">
          {stats.map((s, i) => (
            <div key={i} className={`stat-card${vis ? ' anim' : ''}`} style={{ animationDelay: `${i * 0.15}s` }}>
              <span className="stat-icon">{s.icon}</span>
              <span className="stat-val" style={{ color: s.color }}>{s.val}</span>
              <span className="stat-lab">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const WhySection = () => {
  const [ref, vis] = useScrollAnim();
  const data = [
    { icon: '💰', title: 'Lowest Price Guaranteed', desc: 'Best rates with no hidden charges. Transparent pricing — pay only what you see.', color: '#059669' },
    { icon: '🛡️', title: '100% Safe & Secure', desc: 'Verified drivers, GPS tracking, 24/7 helpline. Your safety is our top priority.', color: '#4f46e5' },
    { icon: '⏰', title: '24/7 Availability', desc: 'Round the clock service, 365 days. Early morning, late night — we are always there.', color: '#a855f7' },
    { icon: '🚗', title: 'Well-Maintained Fleet', desc: 'Clean, AC, regularly serviced vehicles. Comfortable seats, smooth rides always.', color: '#d97706' },
    { icon: '📍', title: '500+ Town Coverage', desc: 'From major cities to small towns — every corner of Tamil Nadu covered.', color: '#dc2626' },
    { icon: '🎯', title: 'On-Time Every Time', desc: 'Our drivers are always punctual. Your time is valuable — we respect it.', color: '#0891b2' },
  ];
  return (
    <section id="why" className="section" ref={ref}>
      <div className="container">
        <div className={`section-header${vis ? ' anim' : ''}`}>
          <span className="section-badge">Why MithraTaxi</span>
          <h2 className="section-title">Why Customers <span className="grad-text">Love Us</span></h2>
          <p className="section-sub">Trusted by 50,000+ happy travelers across Tamil Nadu</p>
        </div>
        <div className="why-grid">
          {data.map((r, i) => (
            <div key={i} className={`why-card${vis ? ' anim' : ''}`} style={{ animationDelay: `${i * 0.1}s` }}>
              <div className="why-icon-wrap" style={{ background: `${r.color}10`, boxShadow: `0 4px 20px ${r.color}12` }}>
                <span className="why-icon">{r.icon}</span>
              </div>
              <div><h4 className="why-title">{r.title}</h4><p className="why-desc">{r.desc}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const TestimonialsSection = () => {
  const [ref, vis] = useScrollAnim();
  const [act, setAct] = useState(0);
  useEffect(() => { const t = setInterval(() => setAct(p => (p + 1) % testimonials.length), 4500); return () => clearInterval(t); }, []);
  return (
    <section id="testimonials" className="section section-alt" ref={ref}>
      <div className="container">
        <div className={`section-header${vis ? ' anim' : ''}`}>
          <span className="section-badge">Customer Love</span>
          <h2 className="section-title">What Travelers <span className="grad-text">Say</span></h2>
        </div>
        <div className="testi-carousel">
          <div className="testi-track" style={{ transform: `translateX(-${act * 100}%)` }}>
            {testimonials.map((t, i) => (
              <div key={i} className="testi-slide">
                <div className="testi-card">
                  <div className="testi-stars">{'⭐'.repeat(t.stars)}</div>
                  <p className="testi-text">"{t.text}"</p>
                  <div className="testi-author">
                    <div className="testi-avatar" style={{ background: ['#6366f1', '#a855f7', '#f59e0b', '#059669', '#dc2626', '#0891b2'][i % 6] }}>{t.name[0]}</div>
                    <div><div className="testi-name">{t.name}</div><div className="testi-city">📍 {t.city}</div></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="testi-dots">
            {testimonials.map((_, i) => <button key={i} className={`testi-dot${i === act ? ' active' : ''}`} onClick={() => setAct(i)} />)}
          </div>
        </div>
      </div>
    </section>
  );
};

const FAQSection = () => {
  const [ref, vis] = useScrollAnim();
  const [open, setOpen] = useState(null);
  return (
    <section id="faq" className="section" ref={ref}>
      <div className="container">
        <div className={`section-header${vis ? ' anim' : ''}`}>
          <span className="section-badge">Got Questions?</span>
          <h2 className="section-title">Frequently Asked <span className="grad-text">Questions</span></h2>
        </div>
        <div className="faq-list">
          {faqs.map((f, i) => (
            <div key={i} className={`faq-item${open === i ? ' open' : ''}${vis ? ' anim' : ''}`} style={{ animationDelay: `${i * 0.07}s` }}>
              <button className="faq-q" onClick={() => setOpen(open === i ? null : i)}>
                <span>{f.q}</span><span className="faq-tog">{open === i ? '−' : '+'}</span>
              </button>
              <div className="faq-a"><p>{f.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ContactSection = () => {
  const [ref, vis] = useScrollAnim();
  const [form, setForm] = useState({ name:'',phone:'',email:'',from:'',to:'',date:'',msg:'' });
  const [sent, setSent] = useState(false);
  const submit = (e) => { e.preventDefault(); setSent(true); setTimeout(() => setSent(false),4000); };
  const up = (k,v) => setForm({...form,[k]:v});

  const offices = [
    {
      city: 'Ramanathapuram',
      address: 'Main Road, Near Bus Stand, Ramanathapuram - 623501',
      icon: '🏛️'
    },
    {
      city: 'Karaikudi',
      address: 'Sekkalai Road, Near Railway Station, Karaikudi - 630001',
      icon: '🏢'
    },
    {
      city: 'Sivagangai',
      address: 'Collector Office Road, Sivagangai - 630561',
      icon: '🏣'
    }
  ];

  return (
    <section id="contact" className="section section-alt" ref={ref}>
      <div className="container">
        <div className={`section-header${vis?' anim':''}`}>
          <span className="section-badge">Reach Us</span>
          <h2 className="section-title">Contact <span className="grad-text">MithraTaxi</span></h2>
          <p className="section-sub">We're available 24/7 to assist you</p>
        </div>
        <div className="contact-grid">
          <div className={`contact-cards${vis?' anim':''}`}>
            {/* Phone */}
            <div className="contact-card">
              <span className="cc-icon">📞</span>
              <h4>Call Us</h4>
              <a href={PHONE_LINK}>+91 {PHONE}</a>
            </div>
            
            {/* WhatsApp */}
            <div className="contact-card">
              <span className="cc-icon">💬</span>
              <h4>WhatsApp</h4>
              <a href={WA_LINK} target="_blank" rel="noreferrer">+91 {PHONE}</a>
            </div>
            
            {/* Email */}
            <div className="contact-card">
              <span className="cc-icon">📧</span>
              <h4>Email Us</h4>
              <a href="mailto:booking@manitaxi.com">booking@mithrataxi.com</a>
            </div>
            
            {/* Working Hours */}
            <div className="contact-card">
              <span className="cc-icon">⏰</span>
              <h4>Working Hours</h4>
              <span>24/7, 365 Days</span>
            </div>
          </div>
          
          {/* Contact Form */}
          <form className={`contact-form${vis?' anim':''}`} onSubmit={submit} style={{animationDelay:'0.2s'}}>
            {sent ? (
              <div className="form-success"><span className="fs-icon">✅</span><h3>Thank You!</h3><p>We'll contact you within 5 minutes.</p></div>
            ) : (<>
              <h3 className="cf-title">📝 Send Enquiry</h3>
              <div className="cf-grid">
                <input placeholder="Your Name *" required value={form.name} onChange={e => up('name',e.target.value)}/>
                <input placeholder="Phone Number *" required type="tel" value={form.phone} onChange={e => up('phone',e.target.value)}/>
                <input placeholder="Email Address" type="email" value={form.email} onChange={e => up('email',e.target.value)}/>
                <input placeholder="Travel Date" type="date" value={form.date} onChange={e => up('date',e.target.value)}/>
                <input placeholder="Pickup Location" value={form.from} onChange={e => up('from',e.target.value)}/>
                <input placeholder="Drop Location" value={form.to} onChange={e => up('to',e.target.value)}/>
              </div>
              <textarea placeholder="Any special requirements..." rows={3} value={form.msg} onChange={e => up('msg',e.target.value)}/>
              <button type="submit" className="glow-btn">🚀 Submit Enquiry</button>
            </>)}
          </form>
        </div>
        
        {/* Office Locations */}
        <div className={`offices-section${vis?' anim':''}`} style={{animationDelay:'0.3s'}}>
          <h3 className="offices-title">🏢 Our Offices</h3>
          <div className="offices-grid">
            {offices.map((office, i) => (
              <div key={i} className="office-card">
                <div className="office-icon">{office.icon}</div>
                <div className="office-info">
                  <h4 className="office-city">{office.city}</h4>
                  <p className="office-address">📍 {office.address}</p>
                  <a href={`https://maps.google.com/?q=${encodeURIComponent(office.address)}`} target="_blank" rel="noreferrer" className="office-map-link">
                    🗺️ View on Map →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-grid">
        <div className="footer-col">
        <div className="f-logo">
  <img src={logo2} alt="ManiTaxi" className="footer-logo-img" />
  <span>Mithra<span className="logo-accent">Taxi</span></span>
</div>
          <p className="f-desc">Your trusted taxi partner across Tamil Nadu. Covering all 38 districts, 500+ towns. Safe, affordable rides 24/7.</p>
          <div className="f-social">
            {['📘', '🐦', '📷', '▶️'].map((s, i) => <a key={i} href="#" className="social-btn">{s}</a>)}
          </div>
        </div>
        <div className="footer-col">
          <h4>Quick Links</h4>
          {[['#hero', 'Home'], ['#services', 'Services'], ['#fleet', 'Our Fleet'], ['#cities', 'Cities'], ['#fare', 'Fare Calculator'], ['#contact', 'Contact']].map(([h, l]) => <a key={h} href={h}>{l}</a>)}
        </div>
        <div className="footer-col">
          <h4>Services</h4>
          {['One Way Taxi', 'Round Trip', 'Airport Transfer', 'Local Taxi', 'Corporate Travel', 'Tour Packages'].map(s => <a key={s} href="#services">{s}</a>)}
        </div>
        <div className="footer-col">
          <h4>Top Cities</h4>
          {['Chennai', 'Coimbatore', 'Madurai', 'Trichy', 'Salem', 'Ooty', 'Kanyakumari', 'Pondicherry'].map(c => <a key={c} href="#cities">{c}</a>)}
        </div>
        <div className="footer-col">
          <h4>Contact Info</h4>
          <p>📞 +91 {PHONE}</p>
          <p>💬 WhatsApp Available</p>
          <p>📧 booking@mithrataxi.com</p>
          <p>📍 Tamil Nadu, India</p>
          <p>⏰ 24/7, 365 Days</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 MithraTaxi. All Rights Reserved. | Covering all 38 Districts of Tamil Nadu ❤️</p>
      </div>
    </div>
  </footer>
);

const FloatingBtns = () => (
  <div className="floating-btns">
    <a href={WA_LINK} className="float-btn wa" target="_blank" rel="noreferrer" title="Chat on WhatsApp">💬</a>
    <a href={PHONE_LINK} className="float-btn ph" title="Call Now">📞</a>
  </div>
);

// ==================== APP ====================
export default function App() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  return (
    <>
      <style>{CSS}</style>
      {/* <TopBar /> */}
      <Navbar scrolled={scrolled} />
      <HeroSection />
      <ServicesSection />
      <HowItWorks />
      <StatsSection />
      <FleetSection />
      <CitiesSection />
      <FareCalculator />
      <RoutesSection />
      
      <WhySection />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <FloatingBtns />
    </>
  );
}

// ==================== COMPLETE CSS ====================
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Poppins:wght@400;500;600;700;800;900&display=swap');

*,*::before,*::after{margin:0;padding:0;box-sizing:border-box}

:root{
  --bg:#fffff2;--bg2:#ffffff;--bg3:#f0f4ff;
  --primary:#4f46e5;--purple:#7c3aed;--amber:#f59e0b;
  --text:#0f172a;--text2:#64748b;--text3:#94a3b8;
  --border:#e2e8f0;--border2:#cbd5e1;
  --card:#ffffff;--card-shadow:0 4px 24px rgba(0,0,0,0.06);
  --card-shadow-hover:0 12px 40px rgba(0,0,0,0.12);
  --gradient:linear-gradient(135deg,#6366f1,#a855f7,#ec4899);
  --gradient2:linear-gradient(135deg,#4f46e5,#7c3aed);
}

/* ====== HEAVIER FONTS GLOBALLY ====== */

/* Body text: 400 → 500 */
body{font-weight:500}

/* Navigation links */
.nav-link{font-weight:600}

/* All headings heavier */
.section-title{font-weight:900}
.hero-title{font-weight:900}
.bf-title{font-weight:800}
.cf-title{font-weight:800}

/* Card titles */
.sc-title{font-weight:800}
.fc-name{font-weight:800}
.city-name{font-weight:800}
.why-title{font-weight:800}
.step-title{font-weight:800}
.faq-q span{font-weight:700}

/* Descriptions: 400 → 500 */
.sc-desc{font-weight:500}
.fc-desc{font-weight:500}
.city-desc{font-weight:500}
.why-desc{font-weight:500}
.step-desc{font-weight:500}
.hero-sub{font-weight:500}
.section-sub{font-weight:500}

/* Buttons heavier */
.glow-btn{font-weight:800}
.sc-btn{font-weight:700}
.fc-book{font-weight:800}
.nav-cta{font-weight:700}
.fr-btn{font-weight:800}

/* Labels */
.bf-group label{font-weight:700}
.fc-pill-label{font-weight:700}
.location-picker>label{font-weight:700}

/* Badges */
.section-badge{font-weight:700}
.hero-badge{font-weight:700}
.fc-type-badge{font-weight:800}

/* Stats */
.stat-val{font-weight:900}
.stat-lab{font-weight:600}
.hs-num{font-weight:800}
.hs-lab{font-weight:600}

/* Prices */
.fc-pill-rate{font-weight:900}
.fc-rate{font-weight:900}
.fr-fare{font-weight:900}
.fci-fare{font-weight:900}

/* Footer */
.footer-col h4{font-weight:800}
.footer-col a{font-weight:500}
.footer-col p{font-weight:500}
.f-desc{font-weight:500}

/* Testimonials */
.testi-text{font-weight:500}
.testi-name{font-weight:700}

/* FAQ */
.faq-q{font-weight:700}
.faq-a p{font-weight:500}

/* Contact */
.contact-card h4{font-weight:800}

/* Form inputs */
.bf-group select,.bf-group input{font-weight:500}
.contact-form input,.contact-form textarea{font-weight:500}

/* Fare calculator */
.fare-route-info h4{font-weight:800}
.fci-name{font-weight:800}

/* Route cards */
.rc-from,.rc-to{font-weight:800}

html,body{overflow-x:hidden;width:100%}
body{font-family:'Inter',sans-serif;background:var(--bg);color:var(--text);line-height:1.6}
.container{max-width:1280px;margin:0 auto;padding:0 20px;box-sizing:border-box;width:100%}
img{max-width:100%;display:block}
a{text-decoration:none}

/* TOPBAR */
.topbar{background:linear-gradient(90deg,#4f46e5,#7c3aed);padding:8px 0;font-size:13px;color:rgba(255,255,255,0.9)}
.topbar-inner{max-width:1280px;margin:0 auto;padding:0 20px;display:flex;justify-content:space-between;flex-wrap:wrap;gap:8px}
.topbar-left,.topbar-right{display:flex;gap:20px;align-items:center}
.topbar a{color:rgba(255,255,255,0.95)}
.topbar a:hover{color:#fff}

/* NAVBAR */
.navbar{position:fixed;top:0;left:0;right:0;z-index:1000;padding:14px 0;transition:all .4s;background:transparent}
.navbar.scrolled{background:rgba(255,255,255,0.95);backdrop-filter:blur(20px);border-bottom:1px solid var(--border);padding:10px 0;box-shadow:0 2px 20px rgba(0,0,0,0.06)}
.nav-inner{max-width:1280px;margin:0 auto;padding:0 20px;display:flex;align-items:center;justify-content:space-between}
.logo{display:flex;align-items:center;gap:10px;cursor:pointer}
.logo-icon{font-size:32px;filter:drop-shadow(0 2px 6px rgba(99,102,241,0.3))}
.logo-text{font-family:'Orbitron',sans-serif;font-size:24px;font-weight:800;color:var(--text)}
.logo-accent{background:var(--gradient2);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.nav-links{display:flex;gap:2px;align-items:center}
.nav-link{background:none;border:none;color:var(--text2);font-size:13px;padding:8px 10px;cursor:pointer;border-radius:8px;transition:.3s;font-family:inherit;font-weight:500}
.nav-link:hover{color:var(--primary);background:rgba(99,102,241,0.06)}
.nav-cta{background:var(--gradient2);color:#fff;padding:10px 24px;border-radius:50px;font-weight:600;font-size:14px;box-shadow:0 4px 15px rgba(99,102,241,0.3);transition:.3s}
.nav-cta:hover{transform:translateY(-2px);box-shadow:0 6px 25px rgba(99,102,241,0.4)}
.nav-cta-mobile{display:none}
.hamburger{display:none;flex-direction:column;gap:5px;background:none;border:none;cursor:pointer;padding:5px}
.hamburger span{width:24px;height:2.5px;background:var(--text);border-radius:3px;transition:.3s}
.nav-overlay{display:none}

/* HERO */
/* HERO BACKGROUND BANNER */
.hero-banner{
  position:absolute;
  top:0;left:0;right:0;bottom:0;
  background:url('https://plus.unsplash.com/premium_photo-1729018715734-ae43c1fb56de?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fHRheGl8ZW58MHx8MHx8fDA%3D&h=1080&fit=crop') center/cover no-repeat;
  z-index:0;
}

/* ====== DARKER HERO TEXT FOR BETTER READABILITY ====== */

/* Hero Title - Darker gradient */
.hero-title{
  font-family:'Orbitron',sans-serif;
  font-size:clamp(24px,3.5vw,44px);
  font-weight:900;
  line-height:1.2;
  margin-bottom:16px;
  background:linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;
  background-clip:text;
  text-shadow:0 2px 10px rgba(0,0,0,0.1);
}

/* Cursor stays purple */
.cursor{
  animation:blink 1s step-end infinite;
  -webkit-text-fill-color:#4f46e5;
}

/* Hero subtitle - Darker */
.hero-sub{
  font-size:16px;
  color:black;
  line-height:1.8;
  margin-bottom:24px;
  max-width:480px;
  font-weight:700;
  text-shadow:0 1px 2px rgba(255,255,255,0.8);
}

/* Hero badge - Darker */
.hero-badge{
  display:inline-block;
  background:rgba(15,23,42,0.08);
  border:1px solid rgba(15,23,42,0.2);
  padding:8px 20px;
  border-radius:50px;
  font-size:14px;
  color:#0f172a;
  margin-bottom:18px;
  font-weight:700;
  text-shadow:0 1px 2px rgba(255,255,255,0.5);
}

/* Stats numbers - Darker */
.hs-num{
  font-family:'Orbitron',sans-serif;
  font-size:22px;
  font-weight:800;
  background:linear-gradient(135deg, #1e3a8a 0%, #4f46e5 100%);
  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;
  background-clip:text;
}

/* Stats labels - Darker */
.hs-lab{
  font-size:12px;
  color:#1e293b;
  font-weight:700;
}

/* Booking Form Title - Darker */
.bf-title{
  font-family:'Orbitron',sans-serif;
  font-size:18px;
  text-align:center;
  margin-bottom:14px;
  color:#0f172a;
  font-weight:800;
}

/* Form Labels - Darker */
.bf-group label{
  font-size:12px;
  color:#0f172a;
  font-weight:700;
}

/* Location Picker Label */
.location-picker>label{
  display:block;
  font-size:12px;
  color:#0f172a;
  font-weight:700;
  margin-bottom:4px;
}

/* LOGO WITH IMAGE */
.logo{
  display:flex;
  align-items:center;
  gap:10px;
  cursor:pointer;
}
.logo-img{
  width:42px;
  height:42px;
  object-fit:contain;
  border-radius:10px;
  transition:transform .3s;
}
.logo:hover .logo-img{
  transform:scale(1.1) rotate(5deg);
}
.logo-text{
  font-family:'Orbitron',sans-serif;
  font-size:24px;
  font-weight:800;
  color:var(--text);
}
.logo-accent{
  background:var(--gradient2);
  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;
  background-clip:text;
}

/* Trip Toggle Buttons (inactive) */
.tt-btn{
  flex:1;
  padding:9px;
  border:none;
  background:none;
  color:#1e293b;
  cursor:pointer;
  border-radius:10px;
  font-weight:700;
  font-size:13px;
  transition:.3s;
  font-family:inherit;
}

/* Fare Result Text */
.fr-route{
  font-family:'Orbitron',sans-serif;
  font-size:15px;
  color:#1e3a8a;
  margin-bottom:8px;
  font-weight:800;
}

.fr-tag{
  font-size:12px;
  color:#0f172a;
  background:rgba(255,255,255,0.9);
  padding:4px 12px;
  border-radius:50px;
  border:1px solid rgba(15,23,42,0.15);
  font-weight:600;
}

.fr-break{
  font-size:12px;
  color:#334155;
  margin-bottom:12px;
  font-weight:600;
}

.fr-rate-info{
  font-size:12px;
  color:#065f46;
  font-weight:700;
  margin-bottom:12px;
  padding:6px 14px;
  background:rgba(5,150,105,0.1);
  border-radius:50px;
}

.hero-blob{position:absolute;border-radius:50%;filter:blur(80px);opacity:.5;pointer-events:none;z-index:1}
.hero-content{position:relative;z-index:2;...}
/* Light overlay for readability */
/* Hero banner overlay - slightly darker for better text contrast */
.hero-banner::before{
  content:'';
  position:absolute;
  top:0;left:0;right:0;bottom:0;
  background:linear-gradient(
    135deg,
    rgba(255,255,255,0.92) 0%,
    rgba(248,250,252,0.88) 40%,
    rgba(240,244,255,0.92) 100%
  );
}

/* Optional: Animated subtle zoom effect */
.hero-banner::after{
  content:'';
  position:absolute;
  top:0;left:0;right:0;bottom:0;
  background:inherit;
  background-size:cover;
  animation:bannerZoom 20s ease-in-out infinite alternate;
  opacity:0.2;
}

@keyframes bannerZoom{
  0%{transform:scale(1)}
  100%{transform:scale(1.1)}
}
.hero{
  min-height:100vh;
  position:relative;
  display:flex;
  align-items:center;
  overflow:hidden;
  padding-top:80px;
  max-width:100vw;
  background:chennai center/cover no-repeat;
}

/* Dark overlay on top of banner */
.hero::before{
  content:'';
  position:absolute;
  top:0;left:0;right:0;bottom:0;
  background:linear-gradient(135deg, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.85) 50%, rgba(240,244,255,0.90) 100%);
  z-index:0;
}.hero-blob{position:absolute;border-radius:50%;filter:blur(80px);opacity:.5;pointer-events:none;z-index:0}
.hero-blob-1{width:min(500px,80vw);height:min(500px,80vw);background:rgba(99,102,241,0.12);top:-150px;right:0;animation:bf1 20s ease-in-out infinite}
.hero-blob-2{width:min(400px,70vw);height:min(400px,70vw);background:rgba(168,85,247,0.10);bottom:-100px;left:0;animation:bf2 25s ease-in-out infinite}
.hero-blob-3{width:min(300px,60vw);height:min(300px,60vw);background:rgba(245,158,11,0.08);top:50%;left:50%;transform:translate(-50%,-50%);animation:bf3 18s ease-in-out infinite}
@keyframes bf1{0%,100%{transform:translate(0,0) scale(1)}50%{transform:translate(-80px,60px) scale(1.1)}}
@keyframes bf2{0%,100%{transform:translate(0,0) scale(1)}50%{transform:translate(60px,-40px) scale(1.15)}}
@keyframes bf3{0%,100%{transform:translate(-50%,-50%) scale(1)}50%{transform:translate(-50%,-50%) scale(1.2)}}

.hero-particles{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;pointer-events:none;max-width:100%}
.particle{position:absolute;width:6px;height:6px;border-radius:50%;opacity:.25;animation:pu linear infinite}
@keyframes pu{0%{transform:translateY(0) scale(1);opacity:.25}50%{opacity:.5}100%{transform:translateY(-100vh) scale(0);opacity:0}}

.hero-content{position:relative;z-index:2;display:grid;grid-template-columns:1fr 1fr;gap:40px;align-items:center;max-width:100%;width:100%;margin:0 auto;padding:40px 20px;box-sizing:border-box}
.hero-badge{display:inline-block;background:rgba(99,102,241,0.08);border:1px solid rgba(99,102,241,0.2);padding:8px 20px;border-radius:50px;font-size:14px;color:var(--primary);margin-bottom:18px;font-weight:600;animation:bp 2.5s infinite}
@keyframes bp{0%,100%{box-shadow:0 0 5px rgba(99,102,241,0.1)}50%{box-shadow:0 0 20px rgba(99,102,241,0.2)}}

.hero-title{font-family:'Orbitron',sans-serif;font-size:clamp(24px,3.5vw,44px);font-weight:900;line-height:1.2;margin-bottom:16px;background:linear-gradient(135deg,#1e293b,#4f46e5,#7c3aed);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.cursor{animation:blink 1s step-end infinite;-webkit-text-fill-color:#4f46e5}
@keyframes blink{0%,100%{opacity:1}50%{opacity:0}}

.hero-sub{font-size:15px;color:var(--text2);line-height:1.8;margin-bottom:24px;max-width:480px}
.hero-stats-row{display:flex;gap:24px;flex-wrap:wrap}
.hero-stat{display:flex;flex-direction:column}
.hs-num{font-family:'Orbitron',sans-serif;font-size:20px;font-weight:700;background:var(--gradient2);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.hs-lab{font-size:12px;color:var(--text2);font-weight:500}

.f-logo{
  display:flex;
  align-items:center;
  gap:10px;
  font-family:'Orbitron',sans-serif;
  font-size:22px;
  font-weight:800;
  color:#fff;
  margin-bottom:12px;
}
.footer-logo-img{
  width:38px;
  height:38px;
  object-fit:contain;
  border-radius:10px;
}

/* LOCATION PICKER */
.location-picker{margin-bottom:10px}
.location-picker>label{display:block;font-size:12px;color:var(--text2);font-weight:600;margin-bottom:4px}
.lp-selects{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.lp-district,.lp-town{padding:11px 12px;background:var(--bg2);border:1px solid var(--border);border-radius:10px;color:var(--text);font-size:13px;outline:none;transition:.3s;font-family:inherit;width:100%}
.lp-district:focus,.lp-town:focus{border-color:var(--primary);box-shadow:0 0 0 3px rgba(99,102,241,0.1)}
.lp-town:disabled{opacity:.5;cursor:not-allowed}

/* BOOKING FORM */
.hero-form-wrapper{perspective:1000px}
.booking-form{padding:24px;border-radius:20px;background:var(--card);border:1px solid var(--border);box-shadow:var(--card-shadow);transform:rotateY(-2deg);transition:transform .5s,box-shadow .5s;animation:ff 6s ease-in-out infinite}
.booking-form:hover{transform:rotateY(0) scale(1.01);box-shadow:var(--card-shadow-hover)}
@keyframes ff{0%,100%{transform:rotateY(-2deg) translateY(0)}50%{transform:rotateY(-2deg) translateY(-6px)}}

.bf-title{font-family:'Orbitron',sans-serif;font-size:17px;text-align:center;margin-bottom:14px;color:var(--text)}
.trip-toggle{display:flex;background:var(--bg2);border-radius:12px;padding:4px;margin-bottom:14px;border:1px solid var(--border)}
.tt-btn{flex:1;padding:9px;border:none;background:none;color:var(--text2);cursor:pointer;border-radius:10px;font-weight:600;font-size:13px;transition:.3s;font-family:inherit}
.tt-btn.active{background:var(--gradient2);color:#fff;box-shadow:0 4px 15px rgba(99,102,241,0.3)}
.bf-locations{margin-bottom:10px}
.bf-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px}
.bf-group{display:flex;flex-direction:column;gap:4px}
.bf-full{grid-column:1/-1;margin-bottom:10px}
.bf-group label{font-size:12px;color:var(--text2);font-weight:600}
.bf-group select,.bf-group input{padding:11px 12px;background:var(--bg2);border:1px solid var(--border);border-radius:10px;color:var(--text);font-size:13px;outline:none;transition:.3s;font-family:inherit}
.bf-group select:focus,.bf-group input:focus{border-color:var(--primary);box-shadow:0 0 0 3px rgba(99,102,241,0.1)}

.glow-btn{width:100%;padding:13px;border:none;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;transition:all .3s;font-family:inherit;background:var(--gradient2);color:#fff;box-shadow:0 4px 20px rgba(99,102,241,0.3);position:relative;overflow:hidden}
.glow-btn::before{content:'';position:absolute;top:-50%;left:-50%;width:200%;height:200%;background:linear-gradient(45deg,transparent,rgba(255,255,255,0.15),transparent);transform:rotate(45deg);transition:.6s}
.glow-btn:hover::before{left:100%}
.glow-btn:hover{transform:translateY(-2px);box-shadow:0 8px 30px rgba(99,102,241,0.4)}

.fare-result{margin-top:16px;padding:18px;background:linear-gradient(135deg,rgba(99,102,241,0.04),rgba(168,85,247,0.04));border:1px solid rgba(99,102,241,0.15);border-radius:14px;text-align:center;animation:fadeIn .5s}
.fr-route{font-family:'Orbitron',sans-serif;font-size:14px;color:var(--primary);margin-bottom:8px}
.fr-tags{display:flex;justify-content:center;gap:8px;flex-wrap:wrap;margin-bottom:8px}
.fr-tag{font-size:11px;color:var(--text2);background:var(--bg2);padding:3px 10px;border-radius:50px;border:1px solid var(--border)}
.fr-fare{font-family:'Orbitron',sans-serif;font-size:32px;font-weight:900;background:var(--gradient2);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.fr-break{font-size:11px;color:var(--text3);margin-bottom:12px}
.fr-actions{display:flex;gap:10px;justify-content:center;flex-wrap:wrap}
.fr-btn{padding:10px 22px;border-radius:50px;font-weight:700;font-size:13px;transition:.3s;display:inline-block}
.fr-btn-call{background:var(--gradient2);color:#fff}
.fr-btn-wa{background:#25d366;color:#fff}
.fr-btn:hover{transform:scale(1.05)}

.hero-wave{position:absolute;bottom:0;left:0;right:0;overflow:hidden}
.hero-wave svg{display:block;width:100%;height:70px;max-width:100vw}

/* SECTIONS */
.section{padding:80px 0;position:relative}
.section-alt{background:var(--bg2)}
.section-header{text-align:center;margin-bottom:50px}
.section-badge{display:inline-block;padding:6px 18px;background:rgba(99,102,241,0.08);border:1px solid rgba(99,102,241,0.15);border-radius:50px;font-size:13px;color:var(--primary);margin-bottom:10px;font-weight:600}
.section-title{font-family:'Orbitron',sans-serif;font-size:clamp(22px,3.2vw,38px);font-weight:800;color:var(--text);margin-bottom:10px}
.grad-text{background:var(--gradient);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.section-sub{font-size:15px;color:var(--text2);max-width:550px;margin:0 auto}

.anim{animation:fiu .7s forwards;opacity:0}
@keyframes fiu{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}

/* SERVICES */
/* SERVICES WITH BACKGROUND IMAGES */
.services-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:20px}

.service-card{
  position:relative;
  border-radius:16px;
  overflow:hidden;
  min-height:320px;
  cursor:pointer;
  transition:all .5s ease;
  box-shadow:var(--card-shadow);
  border:1px solid var(--border);
  background-color:#fff;
}

.sc-content{
  position:relative;
  z-index:2;
  padding:28px;
  text-align:center;
  height:100%;
  min-height:320px;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  transition:all .5s ease;
  background-size:cover;
  background-position:center;
  background-repeat:no-repeat;
}

/* Normal state overlay */
.sc-content::before{
  content:'';
  position:absolute;
  top:0;left:0;right:0;bottom:0;
  background:rgba(255,255,255,0.65);
  z-index:0;
  transition:all .5s ease;
}

/* Accent line at top */
.service-card::after{
  content:'';
  position:absolute;
  top:0;left:0;right:0;
  height:4px;
  background:var(--gradient);
  transform:scaleX(0);
  transition:all .5s ease;
  transform-origin:left;
  z-index:5;
}

.sc-icon-wrap{
  position:relative;z-index:1;
  width:65px;height:65px;
  border-radius:16px;
  display:flex;align-items:center;justify-content:center;
  margin:0 auto 14px;
  border:1px solid;
  transition:all .5s ease;
  backdrop-filter:blur(8px);
}
.sc-icon{font-size:28px;position:relative;z-index:1}

.sc-title{
  position:relative;z-index:1;
  font-size:17px;font-weight:800;
  color:var(--text);
  margin-bottom:8px;
  transition:all .5s ease;
}

.sc-desc{
  position:relative;z-index:1;
  font-size:13px;
  color:var(--text2);
  line-height:1.7;
  margin-bottom:14px;
  transition:all .5s ease;
  font-weight:500;
}

.sc-btn{
  position:relative;z-index:1;
  display:inline-block;
  border:1px solid;
  padding:8px 20px;
  border-radius:50px;
  font-size:12px;
  font-weight:700;
  transition:all .5s ease;
}

/* ====== HOVER / ACTIVE STATE — SOFT DARK + WHITE TEXT ====== */

.service-card:hover,
.service-card.sc-active{
  transform:translateY(-6px) scale(1.02);
  box-shadow:0 15px 35px rgba(99,102,241,0.2);
  border-color:rgba(99,102,241,0.3);
}

/* Soft dark purple overlay — not too harsh */
.service-card:hover .sc-content::before,
.service-card.sc-active .sc-content::before{
  background:linear-gradient(135deg, rgba(30,27,75,0.70) 0%, rgba(67,56,202,0.65) 100%);
}

/* Title — WHITE and visible */
.service-card:hover .sc-title,
.service-card.sc-active .sc-title{
  color:#ffffff;
  text-shadow:0 2px 8px rgba(0,0,0,0.3);
  transform:translateY(-2px);
}

/* Description — light white */
.service-card:hover .sc-desc,
.service-card.sc-active .sc-desc{
  color:rgba(255,255,255,0.92);
  text-shadow:0 1px 4px rgba(0,0,0,0.2);
}

/* Icon — glowing white */
.service-card:hover .sc-icon-wrap,
.service-card.sc-active .sc-icon-wrap{
  transform:scale(1.08) rotate(3deg);
  background:rgba(255,255,255,0.18)!important;
  border-color:rgba(255,255,255,0.4)!important;
  box-shadow:0 8px 25px rgba(99,102,241,0.3);
}

/* Button — white outline */
.service-card:hover .sc-btn,
.service-card.sc-active .sc-btn{
  background:rgba(255,255,255,0.12);
  border-color:rgba(255,255,255,0.5)!important;
  color:#ffffff!important;
  transform:translateY(-2px);
  text-shadow:0 1px 3px rgba(0,0,0,0.2);
}

/* Accent line appears */
.service-card:hover::after,
.service-card.sc-active::after{
  transform:scaleX(1);
}

/* Button extra hover */
.sc-btn:hover{
  background:rgba(255,255,255,0.22)!important;
  transform:scale(1.05) translateY(-2px);
}
/* STEPS */
.steps-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px}
.step-card{text-align:center;position:relative;padding:20px;background:var(--card);border:1px solid var(--border);border-radius:16px;box-shadow:var(--card-shadow);transition:.3s}
.step-card:hover{transform:translateY(-5px);box-shadow:var(--card-shadow-hover)}
.step-num{font-family:'Orbitron',sans-serif;font-size:48px;font-weight:900;position:absolute;top:-5px;right:15px}
.step-icon-wrap{width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 14px;transition:.3s}
.step-card:hover .step-icon-wrap{transform:scale(1.15)}
.step-icon{font-size:32px}
.step-title{font-size:17px;font-weight:700;color:var(--text);margin-bottom:6px}
.step-desc{font-size:13px;color:var(--text2)}

/* FLEET */
.fleet-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:22px}
.fleet-card{background:var(--card);border:1px solid var(--border);border-radius:18px;box-shadow:var(--card-shadow);overflow:hidden;transition:all .4s;position:relative}
.fleet-card:hover{transform:translateY(-10px);box-shadow:var(--card-shadow-hover)}
.fc-ribbon{position:absolute;top:14px;right:-28px;padding:4px 40px;font-size:12px;font-weight:700;color:#fff;transform:rotate(45deg);z-index:2}
.fc-img-wrap{width:100%;height:240px;overflow:hidden;background:#ffffff}
.fc-img{width:100%;height:100%;object-fit:contain;transition:transform .5s;padding:10px}
.fleet-card:hover .fc-img{transform:scale(1.08)}
.fc-body{padding:20px}
.fc-name{font-family:'Orbitron',sans-serif;font-size:17px;font-weight:700;color:var(--text);margin-bottom:2px}
.fc-models{font-size:13px;color:var(--primary);margin-bottom:6px;font-weight:500}
.fc-desc{font-size:13px;color:var(--text2);margin-bottom:10px}
.fc-features{display:flex;gap:12px;font-size:12px;color:var(--text2);margin-bottom:12px;flex-wrap:wrap}
.fc-price{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px}
.fc-rate{font-family:'Orbitron',sans-serif;font-size:26px;font-weight:800}
.fc-per{font-size:14px;color:var(--text2);margin-left:2px}
.fc-base{font-size:12px;color:var(--text3);background:var(--bg2);padding:4px 10px;border-radius:50px}
.fc-book{display:block;text-align:center;padding:11px;border-radius:10px;color:#fff;font-weight:700;font-size:14px;transition:.3s}
.fc-book:hover{transform:scale(1.03);opacity:.9}

/* CITIES */
.cities-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:20px}
.city-card{background:var(--card);border:1px solid var(--border);border-radius:16px;overflow:hidden;box-shadow:var(--card-shadow);transition:all .4s}
.city-card:hover{transform:translateY(-8px);box-shadow:var(--card-shadow-hover)}
.city-img-wrap{position:relative;height:180px;overflow:hidden}
.city-img{width:100%;height:100%;object-fit:cover;transition:transform .5s}
.city-card:hover .city-img{transform:scale(1.1)}
.city-overlay{position:absolute;bottom:0;left:0;right:0;padding:8px 14px;background:linear-gradient(transparent,rgba(0,0,0,0.6))}
.city-tag{font-size:11px;font-weight:600;color:#fff;background:rgba(99,102,241,0.8);padding:3px 10px;border-radius:50px}
.city-body{padding:16px}
.city-name{font-family:'Orbitron',sans-serif;font-size:16px;font-weight:700;color:var(--text);margin-bottom:6px}
.city-desc{font-size:13px;color:var(--text2);line-height:1.6;margin-bottom:10px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.city-book{font-size:13px;font-weight:600;color:var(--primary);transition:.3s;display:inline-block}
.city-book:hover{color:var(--purple);padding-left:5px}

/* DISTRICT COVERAGE */
.district-coverage{margin-top:50px;padding:30px;background:var(--card);border:1px solid var(--border);border-radius:20px;box-shadow:var(--card-shadow)}
.dc-title{font-family:'Orbitron',sans-serif;font-size:20px;text-align:center;margin-bottom:24px;color:var(--text)}
.dc-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:8px}
.dc-item{display:flex;align-items:center;gap:8px;padding:8px 12px;border-radius:8px;transition:.3s;font-size:13px}
.dc-item:hover{background:rgba(99,102,241,0.05)}
.dc-dot{width:8px;height:8px;border-radius:50%;background:var(--gradient2);flex-shrink:0}
.dc-name{color:var(--text);font-weight:500;flex:1}
.dc-count{font-size:11px;color:var(--text3);background:var(--bg2);padding:2px 8px;border-radius:50px}

/* ROUTES */
.routes-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:14px}
.route-card{padding:18px;background:var(--card);border:1px solid var(--border);border-radius:14px;box-shadow:var(--card-shadow);transition:.3s}
.route-card:hover{transform:translateY(-4px);box-shadow:var(--card-shadow-hover);border-color:rgba(99,102,241,0.3)}
.rc-cities{display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:10px}
.rc-from,.rc-to{font-weight:700;color:var(--text);font-size:14px}
.rc-arrow{font-size:16px}
.rc-info{display:flex;justify-content:space-between;font-size:13px;color:var(--text2);margin-bottom:10px}
.rc-price b{color:var(--primary)}
.rc-book{display:block;text-align:center;padding:8px;background:rgba(99,102,241,0.06);border:1px solid rgba(99,102,241,0.15);border-radius:8px;color:var(--primary);font-size:13px;font-weight:600;transition:.3s}
.rc-book:hover{background:rgba(99,102,241,0.12)}

/* FARE CALCULATOR */
.fare-calc{max-width:950px;margin:0 auto;background:var(--card);border:1px solid var(--border);border-radius:20px;box-shadow:var(--card-shadow);padding:30px}
.fare-toggle{display:flex;background:var(--bg2);border-radius:12px;padding:4px;margin-bottom:20px;max-width:300px;margin-left:auto;margin-right:auto;border:1px solid var(--border)}
.fare-toggle button{flex:1;padding:10px;border:none;background:none;color:var(--text2);cursor:pointer;border-radius:10px;font-weight:600;font-size:13px;transition:.3s;font-family:inherit}
.fare-toggle button.active{background:var(--gradient2);color:#fff}
.fare-pickers{display:grid;grid-template-columns:1fr auto 1fr;gap:12px;align-items:end;margin-bottom:16px}
.fare-picker-col{width:100%}
.fare-swap-btn{background:var(--bg2);border:1px solid var(--border);width:42px;height:42px;border-radius:50%;font-size:18px;cursor:pointer;transition:.3s;display:flex;align-items:center;justify-content:center;color:var(--primary);margin-bottom:6px;flex-shrink:0}
.fare-swap-btn:hover{transform:rotate(180deg);background:rgba(99,102,241,0.1)}
.fare-go{margin-top:4px}

.fare-results{margin-top:28px;animation:fadeIn .5s}
.fare-route-info{text-align:center;margin-bottom:20px}
.fare-route-info h4{font-family:'Orbitron',sans-serif;color:var(--primary);font-size:17px}
.fare-route-info p{color:var(--text2);font-size:14px}
.fare-cards{display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:14px}
.fare-card-item{padding:16px;text-align:center;background:var(--bg2);border:2px solid var(--border);border-top:4px solid;border-radius:14px;transition:.3s}
.fare-card-item:hover{transform:translateY(-5px);box-shadow:var(--card-shadow-hover)}
.fci-img{width:100%;height:110px;object-fit:contain;background:var(--bg2);border-radius:8px;}.fci-detail{font-size:11px;color:var(--text3);margin-bottom:4px}
.fci-features{font-size:12px;color:var(--text2);margin-bottom:8px}
.fci-book{display:block;padding:8px;border-radius:8px;color:#fff;font-size:12px;font-weight:700;transition:.3s}
.fci-book:hover{opacity:.9;transform:scale(1.03)}

/* STATS */
.stats-section{padding:60px 0;background:linear-gradient(135deg,rgba(99,102,241,0.04),rgba(168,85,247,0.04),rgba(245,158,11,0.03));border-top:1px solid var(--border);border-bottom:1px solid var(--border)}
.stats-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:24px}
.stat-card{text-align:center;padding:20px}
.stat-icon{font-size:36px;display:block;margin-bottom:6px}
.stat-val{font-family:'Orbitron',sans-serif;font-size:30px;font-weight:900;display:block}
.stat-lab{font-size:13px;color:var(--text2);font-weight:500}

/* WHY */
.why-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(340px,1fr));gap:16px}
.why-card{padding:22px;display:flex;gap:16px;align-items:flex-start;background:var(--card);border:1px solid var(--border);border-radius:14px;box-shadow:var(--card-shadow);transition:all .4s}
.why-card:hover{transform:translateY(-5px);box-shadow:var(--card-shadow-hover)}
.why-icon-wrap{min-width:48px;height:48px;border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:22px}
.why-title{font-size:15px;font-weight:700;color:var(--text);margin-bottom:4px}
.why-desc{font-size:13px;color:var(--text2);line-height:1.6}

/* TESTIMONIALS */
.testi-carousel{max-width:700px;margin:0 auto;overflow:hidden}
.testi-track{display:flex;transition:transform .6s cubic-bezier(.4,0,.2,1)}
.testi-slide{min-width:100%;padding:0 10px}
.testi-card{padding:30px;text-align:center;background:var(--card);border:1px solid var(--border);border-radius:16px;box-shadow:var(--card-shadow)}
.testi-stars{font-size:18px;margin-bottom:12px}
.testi-text{font-size:15px;color:var(--text);line-height:1.8;font-style:italic;margin-bottom:18px}
.testi-author{display:flex;align-items:center;justify-content:center;gap:12px}
.testi-avatar{width:42px;height:42px;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:17px}
.testi-name{font-weight:700;color:var(--text);font-size:14px}
.testi-city{font-size:12px;color:var(--text2)}
.testi-dots{display:flex;justify-content:center;gap:8px;margin-top:20px}
.testi-dot{width:10px;height:10px;border-radius:50%;border:none;background:var(--border2);cursor:pointer;transition:.3s;padding:0}
.testi-dot.active{background:var(--primary);box-shadow:0 0 10px rgba(99,102,241,0.4);width:28px;border-radius:5px}

/* FAQ */
.faq-list{max-width:800px;margin:0 auto;display:flex;flex-direction:column;gap:10px}
.faq-item{background:var(--card);border:1px solid var(--border);border-radius:12px;overflow:hidden;transition:.3s}
.faq-item:hover{border-color:rgba(99,102,241,0.25)}
.faq-item.open{border-color:rgba(99,102,241,0.3);box-shadow:0 4px 16px rgba(99,102,241,0.08)}
.faq-q{width:100%;padding:16px 20px;background:none;border:none;color:var(--text);font-size:14px;font-weight:600;cursor:pointer;display:flex;justify-content:space-between;align-items:center;text-align:left;font-family:inherit}
.faq-tog{font-size:20px;color:var(--primary);min-width:28px;text-align:center;transition:.3s;font-weight:700}
.faq-a{max-height:0;overflow:hidden;transition:max-height .4s}
.faq-item.open .faq-a{max-height:200px}
.faq-a p{padding:0 20px 16px;font-size:14px;color:var(--text2);line-height:1.8}
.faq-item.open .faq-tog{transform:rotate(45deg)}

/* ====== OFFICE LOCATIONS ====== */
.offices-section{
  margin-top:50px;
  padding:30px;
  background:var(--card);
  border:1px solid var(--border);
  border-radius:20px;
  box-shadow:var(--card-shadow);
}

.offices-title{
  font-family:'Orbitron',sans-serif;
  font-size:20px;
  font-weight:800;
  text-align:center;
  margin-bottom:24px;
  color:var(--text);
}

.offices-grid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:20px;
}

.office-card{
  display:flex;
  gap:14px;
  padding:20px;
  background:var(--bg2);
  border:1px solid var(--border);
  border-radius:14px;
  transition:all .3s ease;
}

.office-card:hover{
  transform:translateY(-5px);
  box-shadow:var(--card-shadow-hover);
  border-color:rgba(99,102,241,0.3);
}

.office-icon{
  width:50px;
  height:50px;
  min-width:50px;
  background:var(--gradient2);
  border-radius:12px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:24px;
  box-shadow:0 4px 15px rgba(99,102,241,0.25);
}

.office-info{
  flex:1;
}

.office-city{
  font-family:'Orbitron',sans-serif;
  font-size:16px;
  font-weight:800;
  color:var(--text);
  margin-bottom:6px;
}

.office-address{
  font-size:13px;
  color:var(--text2);
  line-height:1.6;
  margin-bottom:8px;
  font-weight:500;
}

.office-map-link{
  font-size:12px;
  font-weight:700;
  color:var(--primary);
  transition:all .3s;
  display:inline-block;
}

.office-map-link:hover{
  color:#7c3aed;
  transform:translateX(4px);
}

/* Responsive */
@media(max-width:1024px){
  .offices-grid{
    grid-template-columns:repeat(2,1fr);
  }
}

@media(max-width:768px){
  .offices-grid{
    grid-template-columns:1fr;
  }
  
  .office-card{
    padding:16px;
  }
  
  .office-icon{
    width:45px;
    height:45px;
    min-width:45px;
    font-size:20px;
  }
}

/* CONTACT */
.contact-grid{display:grid;grid-template-columns:1fr 1.5fr;gap:24px;align-items:start}
.contact-cards{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.contact-card{padding:20px;text-align:center;background:var(--card);border:1px solid var(--border);border-radius:14px;box-shadow:var(--card-shadow);transition:.3s}
.contact-card:hover{transform:translateY(-5px);box-shadow:var(--card-shadow-hover)}
.cc-icon{font-size:28px;display:block;margin-bottom:6px}
.contact-card h4{font-size:14px;color:var(--text);margin-bottom:6px;font-weight:700}
.contact-card a,.contact-card span{font-size:13px;color:var(--text2);display:block;line-height:1.5}
.contact-card a:hover{color:var(--primary)}

.contact-form{padding:28px;background:var(--card);border:1px solid var(--border);border-radius:16px;box-shadow:var(--card-shadow)}
.cf-title{font-family:'Orbitron',sans-serif;font-size:17px;margin-bottom:16px;color:var(--text)}
.cf-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px}
.contact-form input,.contact-form textarea{width:100%;padding:11px 14px;background:var(--bg2);border:1px solid var(--border);border-radius:10px;color:var(--text);font-size:14px;outline:none;transition:.3s;font-family:inherit;resize:vertical}
.contact-form input:focus,.contact-form textarea:focus{border-color:var(--primary);box-shadow:0 0 0 3px rgba(99,102,241,0.08)}
.contact-form textarea{margin-bottom:10px}
.form-success{text-align:center;padding:40px;animation:fadeIn .5s}
.fs-icon{font-size:48px;display:block;margin-bottom:10px}
.form-success h3{font-family:'Orbitron',sans-serif;color:#059669;font-size:22px;margin-bottom:6px}
.form-success p{color:var(--text2)}

/* FOOTER */
.footer{background:linear-gradient(180deg,#1e1b4b,#0f0a2a);padding:60px 0 0;color:rgba(255,255,255,0.7)}
.footer-grid{display:grid;grid-template-columns:1.5fr 1fr 1fr 1fr 1fr;gap:30px;margin-bottom:40px}
.f-logo{font-family:'Orbitron',sans-serif;font-size:22px;font-weight:800;color:#fff;margin-bottom:12px}
.f-logo span{margin-right:8px}
.f-desc{font-size:13px;line-height:1.8;margin-bottom:14px}
.f-social{display:flex;gap:8px}
.social-btn{width:36px;height:36px;border-radius:10px;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.06);font-size:15px;transition:.3s;border:1px solid rgba(255,255,255,0.08)}
.social-btn:hover{background:rgba(99,102,241,0.2);border-color:rgba(99,102,241,0.4);transform:translateY(-3px)}
.footer-col h4{font-size:14px;font-weight:700;color:#fff;margin-bottom:14px;padding-bottom:8px;position:relative}
.footer-col h4::after{content:'';position:absolute;bottom:0;left:0;width:30px;height:2px;background:var(--gradient)}
.footer-col a{display:block;font-size:13px;color:rgba(255,255,255,0.6);padding:3px 0;transition:.3s}
.footer-col a:hover{color:#fff;padding-left:4px}
.footer-col p{font-size:13px;line-height:1.8}
.footer-bottom{padding:18px 0;border-top:1px solid rgba(255,255,255,0.08);text-align:center}
.footer-bottom p{font-size:13px;color:rgba(255,255,255,0.5)}

/* FLOATING */
.floating-btns{position:fixed;bottom:20px;right:20px;z-index:999;display:flex;flex-direction:column;gap:12px}
.float-btn{width:54px;height:54px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:22px;transition:.3s;box-shadow:0 4px 20px rgba(0,0,0,0.15);animation:fb 3s ease-in-out infinite}
.float-btn.wa{background:#25d366;color:#fff}
.float-btn.ph{background:var(--gradient2);color:#fff}
.float-btn:hover{transform:scale(1.15)}
@keyframes fb{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}

/* RESPONSIVE */
@media(max-width:1024px){
  .hero-content{grid-template-columns:1fr;gap:30px;text-align:center}
  .hero-sub{margin:0 auto 28px}
  .hero-stats-row{justify-content:center}
  .booking-form{transform:none;animation:none}
  .booking-form:hover{transform:none}
  .footer-grid{grid-template-columns:repeat(2,1fr)}
  .contact-grid{grid-template-columns:1fr}
  .fare-pickers{grid-template-columns:1fr;gap:8px}
  .fare-swap-btn{margin:0 auto}
}

@media(max-width:768px){
  .topbar{display:none}
  .nav-links{position:fixed;top:0;right:-300px;width:280px;height:100vh;background:#fff;flex-direction:column;padding:80px 20px 20px;transition:.4s;box-shadow:-4px 0 30px rgba(0,0,0,0.1);z-index:1001;border-left:1px solid var(--border);overflow-y:auto}
  .nav-links.open{right:0}
  .nav-overlay{display:block;position:fixed;inset:0;background:rgba(0,0,0,0.3);z-index:1000}
  .nav-link{width:100%;text-align:left;padding:12px 16px;font-size:15px}
  .nav-cta{display:none}
  .nav-cta-mobile{display:block;padding:12px;background:var(--gradient2);color:#fff;text-align:center;border-radius:10px;font-weight:700;font-size:15px;margin-top:10px}
  .hamburger{display:flex;z-index:1002}
  .hero{padding-top:60px;max-width:100vw}
  .hero-content{padding:20px 16px}
  .booking-form{padding:18px;max-width:100%;overflow:hidden}
  .bf-grid{grid-template-columns:1fr}
  .lp-selects{grid-template-columns:1fr}
  .steps-grid{grid-template-columns:1fr;gap:16px}
  .stats-grid{grid-template-columns:repeat(2,1fr)}
  .contact-cards{grid-template-columns:1fr}
  .cf-grid{grid-template-columns:1fr}
  .footer-grid{grid-template-columns:1fr}
  .fare-cards{grid-template-columns:repeat(2,1fr)}
  .why-grid{grid-template-columns:1fr}
  .dc-grid{grid-template-columns:repeat(auto-fill,minmax(160px,1fr))}
}

@media(max-width:480px){
  .stats-grid{grid-template-columns:1fr 1fr;gap:12px}
  .stat-val{font-size:24px}
  .fleet-grid{grid-template-columns:1fr}
  .routes-grid{grid-template-columns:1fr}
  .fare-cards{grid-template-columns:1fr}
  .hero-stats-row{gap:16px}
  .hs-num{font-size:18px}
  .dc-grid{grid-template-columns:1fr}
}
/* PRICING SUMMARY */
.pricing-summary{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:30px}
.ps-card{padding:20px;background:var(--card);border:1px solid var(--border);border-radius:16px;box-shadow:var(--card-shadow);text-align:center;transition:.3s}
.ps-card:hover{transform:translateY(-5px);box-shadow:var(--card-shadow-hover)}
.ps-type{font-family:'Orbitron',sans-serif;font-size:16px;font-weight:700;display:block;margin-bottom:12px;color:var(--text)}
.ps-rates{display:inline-flex;flex-direction:column;align-items:center;margin:0 10px 8px}
.ps-rate{font-family:'Orbitron',sans-serif;font-size:24px;font-weight:800;color:var(--primary)}
.ps-rate small{font-size:12px;color:var(--text2)}
.ps-rate.ps-round{color:#059669}
.ps-label{font-size:11px;color:var(--text2);font-weight:600;margin-top:2px}
.ps-cars{font-size:11px;color:var(--text3);display:block;margin-top:8px}

.ps-sedan{border-top:3px solid #4f46e5}
.ps-suv{border-top:3px solid #059669}
.ps-premium{border-top:3px solid #dc2626}

/* FLEET FILTER */
.fleet-filter{display:flex;gap:8px;justify-content:center;margin-bottom:30px;flex-wrap:wrap}
.ff-btn{padding:10px 20px;border:1px solid var(--border);border-radius:50px;background:var(--card);color:var(--text2);font-size:13px;font-weight:600;cursor:pointer;transition:.3s;font-family:inherit;display:flex;align-items:center;gap:6px}
.ff-btn:hover{border-color:var(--primary);color:var(--primary)}
.ff-btn.active{background:var(--gradient2);color:#fff;border-color:transparent;box-shadow:0 4px 15px rgba(99,102,241,0.3)}
.ff-count{background:rgba(255,255,255,0.2);padding:2px 8px;border-radius:50px;font-size:11px}
.ff-btn:not(.active) .ff-count{background:var(--bg2)}

/* FLEET CARD UPDATES */
/* COMPACT PRICING PILLS */
.fc-pricing-compact{display:flex;gap:6px;margin-bottom:12px}
.fc-price-pill{flex:1;display:flex;flex-direction:column;align-items:center;gap:2px;padding:8px 4px;background:var(--bg2);border-radius:10px;border:1px solid var(--border);transition:.3s}
.fc-price-pill:hover{border-color:rgba(99,102,241,0.3);transform:translateY(-2px)}
.fc-pill-label{font-size:10px;color:var(--text2);font-weight:600;white-space:nowrap}
.fc-pill-rate{font-family:'Orbitron',sans-serif;font-size:18px;font-weight:800;color:var(--text)}
.fc-pill-rate small{font-size:10px;color:var(--text2);font-weight:500}
.fc-pill-round{background:rgba(5,150,105,0.04);border-color:rgba(5,150,105,0.15)}
.fc-pill-base{background:rgba(99,102,241,0.04);border-color:rgba(99,102,241,0.12)}
.fc-pill-base .fc-pill-rate{font-size:16px;color:var(--text2)}
.fc-type-badge{display:inline-block;font-size:11px;font-weight:700;padding:4px 12px;border-radius:50px;border:1px solid;margin-bottom:8px}
.fc-specs{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin-bottom:12px}
.fc-spec{display:flex;flex-direction:column;align-items:center;gap:2px;font-size:11px;color:var(--text2);padding:6px 4px;background:var(--bg2);border-radius:8px}
.fc-spec-icon{font-size:16px}
.fc-features-list{display:flex;flex-wrap:wrap;gap:4px;margin-bottom:14px}
.fc-feature-tag{font-size:10px;padding:3px 8px;background:rgba(99,102,241,0.06);color:var(--primary);border-radius:50px;font-weight:500}
.fc-more{background:var(--bg2);color:var(--text3)}
.fc-book-btns{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.fc-book{display:block;text-align:center;padding:11px;border-radius:10px;color:#fff;font-weight:700;font-size:13px;transition:.3s}
.fc-book:hover{transform:scale(1.03);opacity:.9}
.fc-book-wa{background:#25d366!important}

/* FARE RESULT ADDITIONS */
.fr-rate-info{font-size:12px;color:#059669;font-weight:600;margin-bottom:12px;padding:6px 14px;background:rgba(5,150,105,0.06);border-radius:50px;display:inline-block}

/* FARE CARD SAVED */
.fci-type{font-size:11px;font-weight:700;margin-bottom:2px}
.fci-saved{font-size:11px;color:#059669;font-weight:700;margin-bottom:6px;padding:3px 8px;background:rgba(5,150,105,0.08);border-radius:50px;display:inline-block}

/* RESPONSIVE UPDATES */
@media(max-width:768px){
  .pricing-summary{grid-template-columns:1fr}
  .fleet-filter{gap:6px}
  .ff-btn{padding:8px 14px;font-size:12px}
  .fc-specs{grid-template-columns:repeat(2,1fr)}
  .fc-pricing{gap:8px}
  .fc-price-divider{width:1px;height:20px}
  .fc-book-btns{grid-template-columns:1fr}
}

@media(max-width:480px){
  .fleet-grid{grid-template-columns:1fr}
  .fare-cards{grid-template-columns:1fr}
}
@media(max-width:768px){
  /* ... keep existing rules, add this ... */
  .fc-pricing-compact{gap:4px}
  .fc-pill-rate{font-size:16px}
  .fc-pill-label{font-size:9px}
  .fc-price-pill{padding:6px 2px}
}

@media(max-width:480px){
  /* ... keep existing rules, add this ... */
  .fc-pricing-compact{gap:4px}
  .fc-pill-rate{font-size:14px}
  .fc-price-pill{padding:6px 2px;border-radius:8px}
}
/* ====== MOBILE: SLIGHTLY BOLDER + SLIGHTLY DARKER (NATURAL LOOK) ====== */
@media(max-width:768px){
  
  /* Body — Just a bit heavier */
  body{
    font-weight:500;
  }
  
  /* Hero Subtitle — Slightly darker */
  .hero-sub{
    color:#334155;
    font-weight:600;
  }
  
  /* Stats Labels — Slightly darker */
  .hs-lab{
    color:#334155;
    font-weight:600;
  }
  
  /* Section Subtitle */
  .section-sub{
    font-weight:500;
    color:#475569;
  }
  
  /* Card Titles — Slightly bolder */
  .sc-title,
  .fc-name,
  .city-name,
  .why-title,
  .step-title,
  .office-city{
    font-weight:800;
  }
  
  /* Descriptions — Slightly darker */
  .sc-desc,
  .fc-desc,
  .city-desc,
  .why-desc,
  .step-desc,
  .office-address{
    font-weight:500;
    color:#475569;
  }
  
  /* Form Labels */
  .bf-group label,
  .location-picker>label{
    color:#1e293b;
    font-weight:700;
  }
  
  /* Buttons — Slightly bolder */
  .glow-btn,
  .sc-btn,
  .fc-book{
    font-weight:700;
  }
  
  /* Testimonials */
  .testi-text{
    font-weight:500;
    color:#374151;
  }
  
  /* FAQ */
  .faq-q span{
    font-weight:700;
  }
  
  .faq-a p{
    font-weight:500;
    color:#475569;
  }
}

/* ====== SMALL PHONES ====== */
@media(max-width:480px){
  body{
    font-weight:500;
  }
}
`;